//   import React, { useState, useEffect } from "react";
//   import { useNavigate, useLocation } from "react-router-dom";
//   import {
//     saveCustomer,
//     getorderno,
//     SaveSosOrder,
//     getStoreSeries,
//     downloadReceipt,
//   } from "../api/service";

//   // ── Load Razorpay SDK ─────────────────────────────────────────────────────
//   function loadRazorpay() {
//     return new Promise((resolve) => {
//       if (window.Razorpay) return resolve(true);
//       const s = document.createElement("script");
//       s.src = "https://checkout.razorpay.com/v1/checkout.js";
//       s.onload = () => resolve(true);
//       s.onerror = () => resolve(false);
//       document.body.appendChild(s);
//     });
//   }
// function loadScript(src, globalKey) {
//   return new Promise((resolve, reject) => {
//     if (window[globalKey]) return resolve(window[globalKey]);
//     const s = document.createElement("script");
//     s.src = src;
//     s.onload = () => resolve(window[globalKey]);
//     s.onerror = () => reject(new Error(`Failed to load ${src}`));
//     document.head.appendChild(s);
//   });
// }
// function truncate2(n) {
//   return Math.floor(n * 100) / 100;
// }
// function round2(n) {
//   return Math.round((n + Number.EPSILON) * 100) / 100;
// }
// function isIOSDevice() {
//   return /iPhone|iPad|iPod/.test(navigator.userAgent);
// }
// function RoundOffBadge({ diff }) {
//   const [open, setOpen] = useState(false);
//   const sign = diff > 0 ? "+" : "−";
//   const abs  = Math.abs(diff).toFixed(2);

//   return (
//     <div style={{ position: "relative", display: "inline-flex" }}>
//       <button
//         onClick={() => setOpen(o => !o)}
//         onBlur={() => setTimeout(() => setOpen(false), 150)}
//         style={{
//           width: 20, height: 20, borderRadius: "50%",
//           background: "rgba(255,255,255,0.18)",
//           border: "1px solid rgba(255,255,255,0.4)",
//           color: "#fff", fontSize: 12, fontWeight: 700,
//           display: "flex", alignItems: "center", justifyContent: "center",
//           cursor: "pointer", padding: 0, lineHeight: 1,
//           transform: "translateY(-14px)",
//         }}
//         aria-label="Round off info"
//       >
//         i
//       </button>
//       {open && (
//         <div style={{
//           position: "absolute", bottom: "calc(100% + 8px)", left: "50%",
//           transform: "translateX(-50%)",
//           background: "#1a1a1a", color: "#fff",
//           fontSize: 11, fontWeight: 500,
//           padding: "6px 10px", borderRadius: 8,
//           whiteSpace: "nowrap",
//           boxShadow: "0 4px 14px rgba(0,0,0,0.3)",
//           zIndex: 20,
//           animation: "roundOffPop 0.15s ease",
//         }}>
//           Round off: {sign}₹{abs}
//           <div style={{
//             position: "absolute", top: "100%", left: "50%",
//             transform: "translateX(-50%)",
//             width: 0, height: 0,
//             borderLeft: "5px solid transparent",
//             borderRight: "5px solid transparent",
//             borderTop: "5px solid #1a1a1a",
//           }} />
//         </div>
//       )}
//     </div>
//   );
// }
// function buildReceiptNode(tracking, storeName, logoUrl) {
//   const {
//     invoiceNo, orderNo, total, items = [],
//     orderType, paymentType, placedAt,
//     discount = 0, discountAmt = 0,
//     discountedTotal
//   } = tracking;

//   //  const totalAmt = parseFloat(discount > 0 ? (discountedTotal ?? total) : total) || 0;
// //    const totalAmt = Math.round(
// //   discount > 0 ? (discountedTotal ?? total) : total
// // );
// const totalAmt = Math.round(
//   discountAmt > 0 ? (discountedTotal ?? total) : total
// );
//   const t1  = parseFloat(total) || 0;
//   const subtotal  = items.reduce((s, i) => s + parseFloat(i.SubTotal || 0), 0);
//   const tax       = Math.max(0, t1 - subtotal);
//   const Receipttax = items.reduce((s, i) => {
//   const pct = (parseFloat(i.Tax1) || 0) + (parseFloat(i.Tax2) || 0);
//   return s + (parseFloat(i.SubTotal || 0) * pct) / 100;
// }, 0);

// const cgstTotal = items.reduce((s, i) => {
//   const pct = parseFloat(i.Tax1) || 0;
//   return s + (parseFloat(i.SubTotal || 0) * pct) / 100;
// }, 0);

// const sgstTotal = items.reduce((s, i) => {
//   const pct = parseFloat(i.Tax2) || 0;
//   return s + (parseFloat(i.SubTotal || 0) * pct) / 100;
// }, 0);

//   const isPaid    = paymentType === "Online";

//   const placedMs  = typeof placedAt === "number" ? placedAt : parseInt(placedAt) || 0;
//   const dt        = placedMs > 0 ? new Date(placedMs) : new Date();

//   const fmtDate   = dt.toLocaleDateString("en-IN", { day:"2-digit", month:"short", year:"numeric" });
//   const fmtTime   = dt.toLocaleTimeString("en-IN", { hour:"2-digit", minute:"2-digit", hour12:true }).toUpperCase();

//   // ── colours ─────────────────────────────────────────────────────────────
//   const RED       = "#C8102E";
//   const RED_LIGHT = "#FFF5F5";
//   const RED_MID   = "#FFE0E0";
//   const DARK      = "#1A1A1A";
//   const GRAY      = "#888888";
//   const GRAY_LT   = "#AAAAAA";
//   const BORDER    = "#EEEEEE";
//   const BG        = "#FAFAFA";
//   const WHITE     = "#FFFFFF";

//   // ── wrapper ──────────────────────────────────────────────────────────────
//   const w = document.createElement("div");
//   w.style.cssText = `
//     font-family: Arial, sans-serif;
//     font-size: 11px;
//     color: ${DARK};
//     background: ${WHITE};
//     width: 397px;           /* 105 mm × 3.78 px/mm */
//     box-sizing: border-box;
//   `;

//   w.innerHTML = `
//     <style>
//       .rcpt * { box-sizing: border-box; margin: 0; padding: 0; }
//       .rcpt    { width: 397px; background: ${WHITE}; font-family: Arial, sans-serif; }
//     </style>

//     <div class="rcpt">

//       <!-- ── HEADER ── -->
//       <div style="background:${WHITE}; padding:14px;">

//         <!-- store name + logo -->
//         <div style="display:flex; align-items:flex-start; justify-content:space-between;">
//           <div>
//             <div style="font-size:9px; color:${GRAY_LT}; text-transform:uppercase; letter-spacing:1px;">INVOICE</div>
//             <div style="font-size:18px; font-weight:700; color:${DARK}; margin-top:3px; line-height:1.1;">${storeName || "Restaurant"}</div>
//           </div>
//           <div id="logo-slot" style="width:50px; height:50px; flex-shrink:0;"></div>
//         </div>

//         <!-- token + total -->
//         <div style="margin-top:14px; background:${RED_LIGHT}; border:1px solid ${RED_MID}; padding:12px; display:flex; align-items:flex-start; justify-content:space-between;">
//           <div>
//             <div style="font-size:8px; font-weight:700; color:${RED}; text-transform:uppercase; letter-spacing:1px;">YOUR TOKEN</div>
//             <div style="font-size:40px; font-weight:700; color:${RED}; line-height:1; margin-top:2px;">${orderNo || "—"}</div>
//           </div>
//           <div style="text-align:right;">
//             <div style="font-size:8px; color:${GRAY_LT}; text-transform:uppercase; letter-spacing:1px;">TOTAL</div>
//             <div style="font-size:26px; font-weight:700; color:${DARK}; margin-top:2px;">₹${totalAmt.toFixed(2)}</div>
//             <div style="font-size:9px; margin-top:4px; color:${isPaid ? "#16A34A" : GRAY};">
//               ${isPaid ? "Paid online" : "Pay at counter"}
//             </div>
//           </div>
//         </div>

//         <!-- chips row -->
//         <div style="margin-top:8px; display:flex; gap:3px;">
//           ${chip("DATE",  fmtDate,  BG, BORDER, GRAY_LT, DARK)}
//           ${chip("TIME",  fmtTime,  BG, BORDER, GRAY_LT, DARK)}
//           ${chip("TYPE",  orderType || "Take Away", BG, BORDER, GRAY_LT, DARK)}
//         </div>
//       </div>

//       <!-- ── ORDER DETAILS ── -->
//       <div style="background:${WHITE}; padding:0 14px;">
//         <div style="border-bottom:1px solid ${BORDER}; padding-bottom:5px; font-size:8px; color:${GRAY_LT}; text-transform:uppercase; letter-spacing:1px;">
//           ORDER DETAILS
//         </div>
  
//         ${items.map(item => {
//             const price   = parseFloat(item.Price) || 0;
//   const taxPct  = (parseFloat(item.Tax1) || 0) + (parseFloat(item.Tax2) || 0);
//   console.log(taxPct)
// console.log(price)
//   // const itemPriceWithoutTax = price / (1 + taxPct / 100);
//   const itemPriceWithoutTax = round2(price / (1 + taxPct / 100));
//   console.log(itemPriceWithoutTax)
//           const lineTotal = (parseFloat(item.SubTotal) || 0) * (parseInt(item.Quantity) || 1);
//           return `
//             <div style="display:flex; justify-content:space-between; align-items:center;
//                         border-bottom:1px solid ${BORDER}; padding:8px 0;">
//               <div>
//                 <div style="font-size:11px; font-weight:700; color:${DARK};">${item.ProductName || "Item"}</div>
//                 <div style="font-size:8px; color:${GRAY_LT}; margin-top:2px;">
//                   ×${item.Quantity}&nbsp;&nbsp;·&nbsp;&nbsp;₹${(itemPriceWithoutTax || 0).toFixed(2)}/each
//                 </div>
//               </div>
//               <div style="font-size:12px; font-weight:700; color:${RED}; flex-shrink:0; padding-left:8px;">
//                 ₹${item.SubTotal.toFixed(2)}
//               </div>
//             </div>
//           `;
//         }).join("")}
//       </div>

    

//       <div style="background:${WHITE}; padding:10px 14px 6px;">
//   ${trow("Subtotal", `₹${subtotal.toFixed(2)}`, false, GRAY, GRAY)}
// ${trow("CGST", `₹${truncate2(cgstTotal).toFixed(2)}`, false, GRAY, GRAY)}
// ${trow("SGST", `₹${truncate2(sgstTotal).toFixed(2)}`, false, GRAY, GRAY)}
//   ${discountAmt > 0 ? trow(`Discount (${discount}%)`, `-₹${parseFloat(discountAmt).toFixed(2)}`, false, "#16A34A", "#16A34A") : ""}
//   <div style="border-top:1px solid ${BORDER}; margin:8px 0 6px;"></div>
//   ${trow("Total Paid", `₹${totalAmt.toFixed(2)}`, true, DARK, RED)}
// </div>

//       <!-- ── INVOICE BAR ── -->
//       <div style="background:${DARK}; padding:9px 14px; display:flex; justify-content:space-between; align-items:center;">
//         <span style="font-size:9px; color:${WHITE};">${invoiceNo || "—"}</span>
//         <span style="font-size:9px; color:${WHITE};">Receipt by BizDom Solutions</span>
//       </div>

//       <!-- ── THANK YOU ── -->
// <div style="background:${RED}; padding:14px; text-align:center;">
//   <div style="font-size:13px; font-weight:700; color:${WHITE};">Thank&nbsp;you for your order!</div>
//  <div
//   style="
//     font-size:9px;
//     color:#FFCCCC;
//     margin-top:4px;
//     text-align:center;
//   "
// >
//   Show token ${orderNo} at the counter to collect
// </div>
// </div>

//     </div>
//   `;

//   // ── logo (base64 img or initial) ────────────────────────────────────────
//   const logoSlot = w.querySelector("#logo-slot");
//   if (logoUrl && logoUrl.startsWith("http")) {
//     const img = document.createElement("img");
//     img.crossOrigin = "anonymous";
//     img.src = logoUrl;
//     img.style.cssText = "width:50px;height:50px;object-fit:contain;";
//     logoSlot.appendChild(img);
//   } else {
//     logoSlot.style.cssText += `background:${RED};display:flex;align-items:center;justify-content:center;`;
//     logoSlot.innerHTML = `<span style="font-size:20px;font-weight:700;color:#fff;">${(storeName||"R")[0].toUpperCase()}</span>`;
//   }

//   return w;
// }
// function chip(label, value, bg, border, labelColor, valueColor) {
//   return `
//     <div style="flex:1; background:${bg}; border:1px solid ${border}; padding:6px 4px; text-align:center;">
//       <div style="font-size:7px; color:${labelColor}; text-transform:uppercase; letter-spacing:0.5px;">${label}</div>
//       <div style="font-size:9px; font-weight:700; color:${valueColor}; margin-top:2px;">${value}</div>
//     </div>
//   `;
// }
// function trow(label, value, grand, lc, vc) {
//   return `
//     <div style="display:flex;justify-content:space-between;align-items:center;margin-bottom:${grand?0:4}px;">
//       <span style="font-size:${grand?12:10}px; font-weight:${grand?"700":"400"}; color:${lc};">${label}</span>
//       <span style="font-size:${grand?14:10}px; font-weight:${grand?"700":"400"}; color:${vc};">${value}</span>
//     </div>
//   `;
// }
// function playSuccessSound() {
//   try {
//     const AudioCtx = window.AudioContext || window.webkitAudioContext;
//     if (!AudioCtx) return;
//     const ctx = new AudioCtx();

//     const run = () => {
//       const rvLen = ctx.sampleRate * 2.2;
//       const rvBuf = ctx.createBuffer(2, rvLen, ctx.sampleRate);
//       for (let c = 0; c < 2; c++) {
//         const d = rvBuf.getChannelData(c);
//         for (let i = 0; i < rvLen; i++)
//           d[i] = (Math.random() * 2 - 1) * Math.pow(1 - i / rvLen, 2.8);
//       }
//       const rv = ctx.createConvolver();
//       rv.buffer = rvBuf;

//       const comp = ctx.createDynamicsCompressor();
//       comp.threshold.value = -14; comp.knee.value = 10;
//       comp.ratio.value = 5; comp.attack.value = 0.002; comp.release.value = 0.20;
//       comp.connect(ctx.destination);

//       const dry = ctx.createGain(); dry.gain.value = 0.68;
//       const wet = ctx.createGain(); wet.gain.value = 0.32;
//       dry.connect(comp); rv.connect(wet); wet.connect(comp);

//       const pan = v => {
//         const p = ctx.createStereoPanner
//           ? ctx.createStereoPanner()
//           : { pan: { value: 0 }, connect: n => n };
//         if (p.pan) p.pan.value = v;
//         return p;
//       };

//       const bell = (freq, t, dur, vol, panV = 0) => {
//         [
//           { type: "sine",     detune: 0,  mix: 1.00 },
//           { type: "triangle", detune: 4,  mix: 0.30 },
//           { type: "sine",     detune: -3, mix: 0.18 },
//         ].forEach(({ type, detune, mix }) => {
//           const osc = ctx.createOscillator();
//           const g   = ctx.createGain();
//           const p   = pan(panV);
//           osc.type = type;
//           osc.frequency.value = type === "sine" && detune === -3 ? freq / 2 : freq;
//           osc.detune.value = detune;
//           const t0 = ctx.currentTime + t;
//           g.gain.setValueAtTime(0, t0);
//           g.gain.linearRampToValueAtTime(vol * mix,    t0 + 0.010);
//           g.gain.setTargetAtTime(vol * mix * 0.50,     t0 + 0.025, 0.055);
//           g.gain.exponentialRampToValueAtTime(0.00001, t0 + dur);
//           osc.connect(g); g.connect(p);
//           if (typeof p.connect === "function" && p !== g) {
//             p.connect(dry); p.connect(rv);
//           } else {
//             g.connect(dry); g.connect(rv);
//           }
//           osc.start(t0); osc.stop(t0 + dur + 0.12);
//         });
//       };

//       const thud = ctx.createOscillator();
//       const tG   = ctx.createGain();
//       thud.type  = "sine";
//       thud.frequency.setValueAtTime(160, ctx.currentTime);
//       thud.frequency.exponentialRampToValueAtTime(38, ctx.currentTime + 0.14);
//       tG.gain.setValueAtTime(0.55, ctx.currentTime);
//       tG.gain.exponentialRampToValueAtTime(0.00001, ctx.currentTime + 0.20);
//       thud.connect(tG); tG.connect(comp);
//       thud.start(ctx.currentTime); thud.stop(ctx.currentTime + 0.24);

//       const nBuf  = ctx.createBuffer(1, ctx.sampleRate * 0.04, ctx.sampleRate);
//       const nD    = nBuf.getChannelData(0);
//       for (let i = 0; i < nD.length; i++) nD[i] = Math.random() * 2 - 1;
//       const nSrc  = ctx.createBufferSource();
//       const nFilt = ctx.createBiquadFilter();
//       const nGain = ctx.createGain();
//       nSrc.buffer = nBuf; nFilt.type = "bandpass";
//       nFilt.frequency.value = 3200; nFilt.Q.value = 0.8;
//       nGain.gain.setValueAtTime(0.18, ctx.currentTime);
//       nGain.gain.exponentialRampToValueAtTime(0.00001, ctx.currentTime + 0.04);
//       nSrc.connect(nFilt); nFilt.connect(nGain); nGain.connect(comp);
//       nSrc.start(ctx.currentTime);

//       bell(293.66, 0.00, 1.30, 0.52, -0.2);
//       bell(369.99, 0.14, 1.15, 0.46,  0.0);
//       bell(440.00, 0.27, 1.05, 0.42,  0.2);
//       bell(587.33, 0.40, 1.55, 0.38,  0.0);
//       bell(739.99, 0.54, 1.80, 0.30,  0.0);

//       const gl  = ctx.createOscillator();
//       const glG = ctx.createGain();
//       gl.type = "sine"; gl.frequency.value = 2349.32;
//       glG.gain.setValueAtTime(0, ctx.currentTime + 0.54);
//       glG.gain.linearRampToValueAtTime(0.06, ctx.currentTime + 0.58);
//       glG.gain.exponentialRampToValueAtTime(0.00001, ctx.currentTime + 1.80);
//       gl.connect(glG); glG.connect(dry); glG.connect(rv);
//       gl.start(ctx.currentTime + 0.54); gl.stop(ctx.currentTime + 1.90);
//     };

//     if (ctx.state === "suspended") {
//       ctx.resume().then(run).catch(() => {});
//     } else {
//       run();
//     }
//   } catch (e) {
//     console.warn("Chime error:", e);
//   }
// }
//   const PP_CSS = `
//     @import url('https://fonts.googleapis.com/css2?family=DM+Sans:wght@400;500;600;700;800&display=swap');
//     @keyframes pp-spin  { to { transform:rotate(360deg); } }
//     @keyframes pp-rise  { from{opacity:0;transform:translateY(14px)}to{opacity:1;transform:translateY(0)} }
//     @keyframes pp-toast { 0%{opacity:0;transform:translateX(-50%) translateY(-10px)} 10%,85%{opacity:1;transform:translateX(-50%) translateY(0)} 100%{opacity:0;transform:translateX(-50%) translateY(-10px)} }
//     @keyframes roundOffPop {
//   from { opacity: 0; transform: translateX(-50%) translateY(4px); }
//   to   { opacity: 1; transform: translateX(-50%) translateY(0); }
// }
//   html, body, #root {
//   -webkit-text-size-adjust: 100%;
//   -moz-text-size-adjust: 100%;
//   text-size-adjust: 100%;
// }
//     .pp-root{font-family:'DM Sans',system-ui,sans-serif;min-height:100vh;background:#f5f0eb;display:flex;flex-direction:column;align-items:center;overflow-y: auto;}
//     .pp-card{background:#fff;border-radius:20px;padding:24px;width:100%;border:0.5px solid #ede8e0;animation:pp-rise 0.35s ease both;}
//     .pp-input-row{display:flex;align-items:center;gap:10px;border:2px solid #e8e0d8;border-radius:12px;padding:13px 16px;background:#faf8f4;transition:border-color 0.2s,background 0.2s;}
//     .pp-input-row:focus-within{border-color:#c8102e;background:#fff;}
//     .pp-input-row input{flex:1;border:none;outline:none;font-size:20px;font-weight:700;background:transparent;color:#1a1a1a;letter-spacing:2px;font-family:'DM Sans',system-ui,sans-serif;}
//     .pp-input-row input::placeholder{font-size:14px;font-weight:400;color:#c0b8b0;letter-spacing:0;}
//     .pp-btn{width:100%;padding:15px;border-radius:13px;font-size:15px;font-weight:700;cursor:pointer;transition:all 0.15s;font-family:'DM Sans',system-ui,sans-serif;display:flex;align-items:center;justify-content:center;gap:8px;}
//     .pp-btn:active:not(:disabled){transform:scale(0.97);}
//     .pp-btn:disabled{cursor:not-allowed;}
//     .pp-spinner{width:18px;height:18px;border:2.5px solid rgba(255,255,255,0.35);border-top-color:#fff;border-radius:50%;animation:pp-spin 0.7s linear infinite;}
//     .pp-toast{position:fixed;top:20px;left:50%;transform:translateX(-50%);padding:11px 20px;border-radius:99px;font-size:13px;font-weight:600;z-index:2000;white-space:nowrap;animation:pp-toast 3.5s ease forwards;}
//     .pp-dot{width:9px;height:9px;border-radius:50%;background:#e8e0d8;transition:background 0.2s,transform 0.2s;}
//     .pp-dot.on{background:#c8102e;transform:scale(1.15);}
//     @media screen and (min-width: 601px) {
//   .pp-body { max-width: min(720px, 90vw) !important; width: 100% !important; }
//   .pp-card { padding: 32px !important; }
// }
// @media screen and (min-width: 601px) and (orientation: landscape) {
//   .pp-body { max-width: min(820px, 86vw) !important; }
// }
//   `;
//   if (!document.getElementById("pp-css2")) {
//     const el = document.createElement("style");
//     el.id = "pp-css2";
//     el.textContent = PP_CSS;
//     document.head.appendChild(el);
//   }

//   const BACKEND = "https://uat-ecom.azurewebsites.net";

//   async function withRetry(fn, tries = 3) {
//     for (let i = 0; i < tries; i++) {
//       try {
//         return await fn();
//       } catch (e) {
//         if (i === tries - 1) throw e;
//         await new Promise((r) => setTimeout(r, 1000 * (i + 1)));
//       }
//     }
//   }

// // function calcOrder(cart, storeId, discountPercent = 0) {
// //   let bill = 0, sub = 0, tax = 0;
// //   const items = [];

// //   //  Generate ONE kotrefid for the entire order
// //   const sharedKotrefid = generateUltraSecureBigInt(storeId);

// //   cart.forEach((p) => {
// //     const q = p.quantity || 1,
// //       m = 1 + ((p.tax1 ?? 0) + (p.tax2 ?? 0)) / 100;
// //     // const rs = parseFloat(((p.sosPrice * q) / m).toFixed(2));
// //      const rsFull = parseFloat(((p.sosPrice * q) / m).toFixed(2));  // base excl. tax

// //   // ── Apply discount to base price ──
  
// //   const itemDiscountAmt = parseFloat(((rsFull * discountPercent) / 100).toFixed(2));
// //   const rs = discountPercent > 0 
// //     ? parseFloat((rsFull - itemDiscountAmt).toFixed(2)) 
// //     : rsFull;
// //     console.log(rs)
// //     // const cg = parseFloat(((rs / q) * ((p.tax1 || 0) / 100) * q).toFixed(2));
// //     // const sg = parseFloat(((rs / q) * ((p.tax2 || 0) / 100) * q).toFixed(2));
// //     const cg = rs * ((p.tax1 || 0) / 100);
// // const sg = rs * ((p.tax2 || 0) / 100);
// //     bill += p.sosPrice * q;
// //     sub += rs;
// //     tax += cg + sg;
// //     items.push({
// //       ProductId: p.id,
// //       ProductName: p.product_Name,
// //       Quantity: q,
// //       Price: parseFloat(p.sosPrice.toFixed(2)),
// //       Tax1: p.tax1,
// //       Tax2: p.tax2,
// //       // Tax1: cg,
// //       // Tax2: sg,
// //       Tax3: 0,
// //       SubTotal: rs,
// //       TotalAmount: rsFull,
// //       ImgUrl: p.product_Imageurl,
// //       Prod_Desc: p.product_Name,
// //        isAddon: false, 
// //       Kotrefid: sharedKotrefid, //  same for all items
// //        DiscountSummary: {           // ← ADD
// //     _type:           "discount_summary",
// //     originalAmount:  parseFloat((p.sosPrice * q).toFixed(2)),
// //     discountPercent: discountPercent,
// //     discountAmount:  parseFloat(((p.sosPrice * q * discountPercent) / 100).toFixed(2)),
// //     totalAmount:     parseFloat(((p.sosPrice * q) - ((p.sosPrice * q * discountPercent) / 100)).toFixed(2)),
// //   },
      
// //     });
// function calcOrder(cart, storeId, discountPercent = 0) {
//   let bill = 0, sub = 0, tax = 0;
//   const items = [];
//   const sharedKotrefid = generateUltraSecureBigInt(storeId);

//   cart.forEach((p) => {
//     const q = p.quantity || 1,
//       m = 1 + ((p.tax1 ?? 0) + (p.tax2 ?? 0)) / 100;
//     const rsFull = parseFloat(((p.sosPrice * q) / m).toFixed(2));

//     // ── minquantity === 1 → this product never gets the discount ──
//     const isDiscountEligible = p.minquantity !== 1;
//     const effDiscount = isDiscountEligible ? discountPercent : 0;

//     const itemDiscountAmt = parseFloat(((rsFull * effDiscount) / 100).toFixed(2));
//     const rs = effDiscount > 0
//       ? parseFloat((rsFull - itemDiscountAmt).toFixed(2))
//       : rsFull;

//     const cg = rs * ((p.tax1 || 0) / 100);
//     const sg = rs * ((p.tax2 || 0) / 100);
//     bill += p.sosPrice * q;
//     sub += rs;
//     tax += cg + sg;

//     items.push({
//       ProductId: p.id,
//       ProductName: p.product_Name,
//       Quantity: q,
//       Price: parseFloat(p.sosPrice.toFixed(2)),
//       Tax1: p.tax1,
//       Tax2: p.tax2,
//       Tax3: 0,
//       SubTotal: rs,
//       TotalAmount: rsFull,
//       ImgUrl: p.product_Imageurl,
//       Prod_Desc: p.product_Name,
//       isAddon: false,
//       Kotrefid: sharedKotrefid,
      
//       DiscountSummary: {
//         _type: "discount_summary",
//         originalAmount: parseFloat((p.sosPrice * q).toFixed(2)),
//         discountPercent: effDiscount,
//         discountAmount: parseFloat(((p.sosPrice * q * effDiscount) / 100).toFixed(2)),
//         totalAmount: parseFloat(((p.sosPrice * q) - ((p.sosPrice * q * effDiscount) / 100)).toFixed(2)),
//       },
//     });

//     (p.addons || []).forEach((a) => {
//       const aq = a.qty || 1,
//         am = 1 + ((a.tax1 ?? 0) + (a.tax2 ?? 0)) / 100;
//       const as2 = parseFloat(((a.sosPrice * aq) / am).toFixed(2));
//       // const ac = parseFloat(((as2 / aq) * ((a.tax1 || 0) / 100) * aq).toFixed(2));
//       // const as3 = parseFloat(((as2 / aq) * ((a.tax2 || 0) / 100) * aq).toFixed(2));
//       const ac  = (as2 / aq) * ((a.tax1 || 0) / 100) * aq;
// const as3 = (as2 / aq) * ((a.tax2 || 0) / 100) * aq;
//       bill += a.sosPrice * aq;
//       sub += as2;
//       tax += ac + as3;
//       items.push({
//         ProductId: a.id,
//         ProductName: a.name,
//         Quantity: aq,
//         Price: parseFloat(a.sosPrice.toFixed(2)),
//         Tax1: ac,
//         Tax2: as3,
//         Tax3: 0,
//         SubTotal: as2,
//         TotalAmount: as2,
//         ImgUrl: a.imageurl,
//         Prod_Desc: a.name,
//          isAddon: false, 
//         Kotrefid: sharedKotrefid, //  same for addons too
//       });
//     });
//   });

//   return {
//     bill: parseFloat(bill.toFixed(2)),
//     sub: parseFloat(sub.toFixed(2)),
//     tax: parseFloat(tax.toFixed(5)),
//     items,
//   };
// }
//   async function pdfBlobToPngBlob(pdfBlob) {
//     try {
//       // ── Load PDF.js only once ──────────────────────────────────────────
//       const pdfjsLib = await new Promise((resolve, reject) => {
//         if (window.pdfjsLib) return resolve(window.pdfjsLib);

//         const script = document.createElement("script");
//         script.src = "https://cdnjs.cloudflare.com/ajax/libs/pdf.js/3.11.174/pdf.min.js";

//         script.onload = () => {
//           window.pdfjsLib.GlobalWorkerOptions.workerSrc =
//             "https://cdnjs.cloudflare.com/ajax/libs/pdf.js/3.11.174/pdf.worker.min.js";
//           resolve(window.pdfjsLib);
//         };

//         script.onerror = () => reject(new Error("PDF.js failed to load"));
//         document.head.appendChild(script);
//       });

//       const arrayBuffer = await pdfBlob.arrayBuffer();
//       const pdf = await pdfjsLib.getDocument({ data: arrayBuffer }).promise;
//       const page = await pdf.getPage(1);

//       // ── Render at 3x for crisp image ──────────────────────────────────
//       const scale    = 3;
//       const viewport = page.getViewport({ scale });
//       const canvas   = document.createElement("canvas");
//       canvas.width   = viewport.width;
//       canvas.height  = viewport.height;

//       const ctx = canvas.getContext("2d");

//       // White background so PNG isn't transparent
//       ctx.fillStyle = "#ffffff";
//       ctx.fillRect(0, 0, canvas.width, canvas.height);

//       await page.render({ canvasContext: ctx, viewport }).promise;

//       return await new Promise((resolve, reject) => {
//         canvas.toBlob(
//           (blob) => blob ? resolve(blob) : reject(new Error("toBlob failed")),
//           "image/png",
//           1.0
//         );
//       });
//     } catch (err) {
//       console.error("PDF → PNG failed:", err);
//       return null;
//     }
//   }
//   // function triggerDownload(blob, filename) {
//   //   const url = URL.createObjectURL(blob);
//   //   const a = document.createElement("a");
//   //   a.href = url;
//   //   a.download = filename;
//   //   document.body.appendChild(a);
//   //   a.click();
//   //   document.body.removeChild(a);
//   //   setTimeout(() => URL.revokeObjectURL(url), 5000);
//   // }
//   function triggerDownload(blob, filename) {
//     const url = URL.createObjectURL(blob);
//     const a = document.createElement("a");
//     a.href = url;
//     a.download = filename;        //  this forces download not open
//     a.style.display = "none";
//     document.body.appendChild(a);
//     a.click();
//     document.body.removeChild(a);
//     setTimeout(() => URL.revokeObjectURL(url), 5000);
//   }
//   function openInNewTab(blob, filename) {
//     const url = URL.createObjectURL(blob);
//     const win = window.open(url, "_blank");
//     if (!win) {
//       // Popup blocked — fallback to anchor click
//       triggerDownload(blob, filename);
//     }
//     setTimeout(() => URL.revokeObjectURL(url), 30000);
//   }
//   // ── Enhanced PDF download with gallery support for mobile ─────────────────
//   // async function downloadAndSaveReceipt(tracking, storeName, logoUrl) {
//   //   try {
//   //     const apiUrl = `http://192.168.88.33:5000/api/Landingpage/generate-invoice`;

//   //     const params = new URLSearchParams({
//   //       invoiceNo:   tracking.invoiceNo,
//   //       orderNo:     tracking.orderNo,
//   //       total:       tracking.total.toString(),
//   //       orderType:   tracking.orderType,
//   //       paymentType: tracking.paymentType,
//   //       storeName:   storeName,
//   //       logoUrl:     logoUrl || "",
//   //       placedAt:    tracking.placedAt.toString(),
//   //       itemsJson:   JSON.stringify(tracking.items),
//   //     });

//   //     const response = await fetch(`${apiUrl}?${params.toString()}`, {
//   //       method: "GET",
//   //       headers: { Accept: "application/pdf" },
//   //     });

//   //     if (!response.ok) throw new Error("PDF generation failed");

//   //     const pdfBlob = await response.blob();
//   //     const safeName = tracking.invoiceNo?.replace(/\//g, "-") ?? "receipt";
//   //     const pdfFilename = `receipt-${safeName}.pdf`;
//   //     const imgFilename = `receipt-${safeName}.png`;

//   //     const isIOS = /iPhone|iPad|iPod/.test(navigator.userAgent);

//   //     // ── STEP 1: Always download PDF ────────────────────────────────────
//   //     if (isIOS) {
//   //       openInNewTab(pdfBlob, pdfFilename);
//   //     } else {
//   //       triggerDownload(pdfBlob, pdfFilename);
//   //     }

//   //     // ── STEP 2: Wait then convert PDF → PNG ────────────────────────────
//   //     await new Promise((r) => setTimeout(r, 800));

//   //     const pngBlob = await pdfBlobToPngBlob(pdfBlob);

//   //     // ── STEP 3: Always download PNG too ────────────────────────────────
//   //     if (pngBlob) {
//   //       await new Promise((r) => setTimeout(r, 500)); // small gap between downloads
//   //       if (isIOS) {
//   //         openInNewTab(pngBlob, imgFilename);
//   //       } else {
//   //         triggerDownload(pngBlob, imgFilename);
//   //       }
//   //     } else {
//   //       console.warn("PNG conversion failed — only PDF downloaded");
//   //     }

//   //     return true;
//   //   } catch (error) {
//   //     console.error("Receipt download error:", error);
//   //     return false;
//   //   }
//   // }
//   async function downloadAndSaveReceipt(tracking, storeName, logoUrl) {
//   try {
//     // load html2canvas + jsPDF from CDN
//     await loadScript(
//       "https://cdnjs.cloudflare.com/ajax/libs/html2canvas/1.4.1/html2canvas.min.js",
//       "html2canvas"
//     );
//     await loadScript(
//       "https://cdnjs.cloudflare.com/ajax/libs/jspdf/2.5.1/jspdf.umd.min.js",
//       "jspdf"
//     );

//     // build & attach hidden receipt node
//     const node = buildReceiptNode(tracking, storeName, logoUrl);
//     node.style.position = "fixed";
//     node.style.top      = "-9999px";
//     node.style.left     = "-9999px";
//     document.body.appendChild(node);

//     // wait for logo image if present
//     const img = node.querySelector("img");
//     if (img) {
//       await new Promise(r => {
//         if (img.complete) return r();
//         img.onload = img.onerror = r;
//         setTimeout(r, 3000); // max 3s wait
//       });
//     }

//     // render to canvas
//     const canvas = await window.html2canvas(node, {
//       scale:            3,
//       useCORS:          true,
//       allowTaint:       false,
//       backgroundColor:  "#FFFFFF",
//       logging:          false,
//     });

//     document.body.removeChild(node);

//     const safeName   = (tracking.invoiceNo || "receipt").replace(/\//g, "-");
//     const pngFilename = `receipt-${safeName}.png`;
//     const pdfFilename = `receipt-${safeName}.pdf`;

//     // ── PNG download ──────────────────────────────────────────────────────
//     canvas.toBlob(pngBlob => {
//       if (pngBlob) triggerDownload(pngBlob, pngFilename);
//     }, "image/png", 1.0);

//     // ── PDF download ──────────────────────────────────────────────────────
//     await new Promise(r => setTimeout(r, 400));

//     const { jsPDF } = window.jspdf;
//     const W_MM  = 105;
//     const H_MM  = (canvas.height / canvas.width) * W_MM;

//     const pdf = new jsPDF({ orientation: "portrait", unit: "mm", format: [W_MM, H_MM] });
//     pdf.addImage(canvas.toDataURL("image/png"), "PNG", 0, 0, W_MM, H_MM);

//     const pdfBlob = pdf.output("blob");
//     await new Promise(r => setTimeout(r, 300));
//     triggerDownload(pdfBlob, pdfFilename);

//     return true;
//   } catch (error) {
//     console.error("Receipt generation error:", error);
//     return false;
//   }
// }
// function generateUltraSecureBigInt(storeId = 1) {
//   const timestamp = Math.floor(Date.now() / 1000);

//   const arr = new Uint32Array(1);
//   crypto.getRandomValues(arr);

//   const random = arr[0] % 10000;

//   return Number(
//     `${timestamp}${storeId
//       .toString()
//       .padStart(2, "0")}${random
//       .toString()
//       .padStart(4, "0")}`
//   );
// }
// function computeEligibleDiscountAmt(cartItems, discountPercent) {
//   if (!discountPercent || discountPercent <= 0) return 0;
//   let amt = 0;
//   cartItems.forEach((p) => {
//     if (p.minquantity === 1) return; // excluded from discount
//     const qty = p.quantity || 1;
//     amt += ((p.sosPrice || 0) * qty * discountPercent) / 100;
//   });
//   return parseFloat(amt.toFixed(2));
// }
//   async function placeOrder({ custId, phoneNum, payTypeId, paidAmt, payOrdId, discountedTotal, discount, discountAmt }) {
//     const storeId   = localStorage.getItem("StoreId");
//     const CompId    = localStorage.getItem("compId");
//     const Macadd    = localStorage.getItem("macAdrs");
//     const typeiD    = localStorage.getItem("ordertypeId");
//     const orderType = localStorage.getItem("orderType") || "Take Away";
//     const cart      = JSON.parse(localStorage.getItem("cart") || "[]");
//     const now       = new Date();
//     const ds        = now.toLocaleDateString("en-GB").split("/").reverse().join("");

//     const or          = await withRetry(() => getorderno(storeId));
//     const ordNo       = or.getOrderIndex[0].ordNo || 0;
//     // const series      = await getStoreSeries(storeId);
//     // const tokenPrefix = series.tokenPrefix;
//     const tokenPrefix = "M";
//     const ino         = `SOS/D/${ds}/${ordNo}`;
//     const token       = `${tokenPrefix}-${String(ordNo).padStart(2, "0")}`;


//     const { bill, sub, tax, items } = calcOrder(cart, storeId, discount ?? 0);
//     const billamount=  Math.round(bill - discountAmt);
//     const d = `${now.getFullYear()}-${String(now.getMonth() + 1).padStart(2, "0")}-${String(now.getDate()).padStart(2, "0")}`;
//     const t = now.toLocaleTimeString("en-GB", { hour12: false });
//     const rawTableName = localStorage.getItem("tableName") || "";
// const tableNameNum = rawTableName.replace(/[^0-9]/g, ""); 
// console.log(tax)
// const eligibleSubtotalBeforeDiscount = cart.reduce((s, p) => {
//   if (p.minquantity === 1) return s; // excluded items don't count
//   return s + (p.sosPrice || 0) * (p.quantity || 1);
// }, 0);

// const effectiveDiscPercent = eligibleSubtotalBeforeDiscount > 0
//   ? parseFloat(((discountAmt / eligibleSubtotalBeforeDiscount) * 100).toFixed(2))
//   : 0;
// // const kotRefId = generateUltraSecureBigInt(storeId);
//     const payload = {
//       qrId:            payTypeId === 1 ? payOrdId : new Date().toISOString(),
//       PayOrdId:        payOrdId,
//       OrderedDate:     d,
//       OrderNo:         parseInt(ordNo),
//       UserId:          3,
//       SourceId:        1,
//       StoreId:         parseInt(storeId),
//       DeliverySoreId:  parseInt(storeId),
//       OrderTypeId:     14,
//       PrevStsId:       typeiD,
//       Invoiceno:       ino,
//       CusId:           parseInt(custId || 0),
//       Custname:        "Guest",
//       Phoneno:         parseInt(phoneNum || 0),
//       DineId:          parseInt(localStorage.getItem("dineTableid")),
//       Type:            1,
//       Billamount:  billamount,
//       TotalAmount:     sub,
//       Taxamount:       tax,
//       Paidamount:     Math.round(parseFloat(paidAmt)),
//       CompanyId:       parseInt(CompId),
//       PaymentTypeId:   payTypeId,
//       OrderStatusId:   1,
//       TransStatusId:   2,
//       Tax1:            parseFloat((tax / 2).toFixed(5)),
//       Tax2:            parseFloat((tax / 2).toFixed(5)),
//       Tax3:            0,
//       BillStatusId:    1,
//      DiscPercent: effectiveDiscPercent,
// DiscAmount:  discountAmt ?? 0,
//       OrderTime:       t,
//       OrderedDateTime: `${d}T${t}`,
//       DeliveryTime:    t,
//       DeliveryDate:    now.toISOString(),
//       DeliveryDateTime:`${d}T${t}`,
//       CreatedDateTime: now.toISOString(),
//       ModifiedDateTime:now.toISOString(),
//       ItmJson:         JSON.stringify(items),
//       ChargeJson:      Macadd,
//       icr: "M",
//       TableName: tableNameNum, 
      
//     };

//     const res = await withRetry(() => SaveSosOrder(payload));
//     console.log(res);
//     if (!res.success) throw new Error("Order save failed — please retry");

//     const tracking = {
//       invoiceNo:   res.invoiceNo,
//       orderNo:    `${tokenPrefix}-${String(res.orderNo).padStart(2, "0")}`,
//       total:       bill,
//       items,
//       orderType,
//       paymentType: payTypeId === 1 ? "Online" : "COD",
//       paid:        payTypeId === 1,
//       placedAt:    Date.now(),
//        discount,        // ← ADD
//   discountAmt,     // ← ADD
//   discountedTotal, // ← ADD
//     };
// console.log(tracking)


//     localStorage.setItem("lastOrder", JSON.stringify(tracking));

//     ["cart", "custid", "userPhone", "lastActiveCategory", "selectedFreeItems", "allowedFreeQty","tableName"]
//       .forEach((k) => localStorage.removeItem(k));

//     const storeName = localStorage.getItem("StoreName") || "Restaurant";
//     const logoUrl   = localStorage.getItem("logo") || "";

//     //  ENHANCED: Download and save receipt with mobile gallery support
//   await downloadAndSaveReceipt(tracking, storeName, logoUrl);

// try { playSuccessSound(); } catch (_) {}   //  closest to gesture — works for ALL paths

// return tracking;
//   }

//   export default function PhonePage() {
//     const [phone, setPhone]   = useState("");
//     const [loading, setLoading] = useState(false);
//     const [label, setLabel]   = useState("");
//     const [toast, setToast]   = useState(null);
// const [showIOSInstruction, setShowIOSInstruction] = useState(false);
//     const location  = useLocation();
//     const navigate  = useNavigate();
//     const { total: stateTotal = 0, discount: discountFromCart = 0 , cart: cartFromState = [], } = location.state || {};
//     const total = stateTotal > 0
//   ? stateTotal
//   : parseFloat(localStorage.getItem("checkoutTotal") || "0");
//     const cart = cartFromState.length > 0
//   ? cartFromState
//   : JSON.parse(localStorage.getItem("cart") || "[]");
//     const Logo      = localStorage.getItem("logo");
//     const storeName = localStorage.getItem("StoreName") || "Restaurant";
// const discount = parseFloat(
//   discountFromCart || localStorage.getItem("storeDiscount") || "0"
// );
// const iosContinueResolveRef = React.useRef(null);

// // const discountAmt     = parseFloat(((total * discount) / 100).toFixed(2));
// // const discountedTotal =  Math.round(total - discountAmt);
// // const discountAmt      = parseFloat(((total * discount) / 100).toFixed(2));
// // const rawDiscountedTotal = total - discountAmt;              // exact value before rounding
// // const discountedTotal  = Math.round(rawDiscountedTotal);      // rounded value shown to user
// // const roundOffDiff     = parseFloat((discountedTotal - rawDiscountedTotal).toFixed(2)); // +0.32 or -0.18 etc

// const discountAmt        = computeEligibleDiscountAmt(cart, discount);
// const rawDiscountedTotal = total - discountAmt;
// const discountedTotal    = Math.round(rawDiscountedTotal);
// const roundOffDiff       = parseFloat((discountedTotal - rawDiscountedTotal).toFixed(2));
//     const showToast = (msg, type = "error") => {
//       setToast({ msg, type });
//       setTimeout(() => setToast(null), 3500);
//     };

//     const handlePhoneChange = (e) => {
//       const v = e.target.value.replace(/\D/g, "");
//       if (v.length > 0 && !/^[6-9]/.test(v)) return;
//       if (v.length <= 10) setPhone(v);
//     };

//     const isValidIndianPhone = (num) => /^[6-9]\d{9}$/.test(num);

//     const phoneError =
//       phone.length === 10 && !isValidIndianPhone(phone)
//         ? "Indian mobile numbers must start with 6, 7, 8, or 9"
//         : null;

//     const phoneValid = phone.length === 10 && isValidIndianPhone(phone);

//     // ── COD (Skip Payment) ────────────────────────────────────────────────────
//   //   const handleCOD = async () => {
//   //       const currentDiscount = discount;
//   // const currentDiscountAmt = parseFloat(((total * currentDiscount) / 100).toFixed(2));
//   // const currentDiscountedTotal = parseFloat((total - currentDiscountAmt).toFixed(2));
//   //     localStorage.setItem("userPhone", "");
//   //     localStorage.setItem("custid", "null");
//   //     setLoading(true);
//   //     setLabel("Placing your order…");
//   //     try {
//   //       const state = await placeOrder({
//   //         custId: null,
//   //         phoneNum: "",
//   //         payTypeId: 2,
//   //         paidAmt: 0,
//   //         payOrdId: "COD",
//   //          discountedTotal: currentDiscountedTotal,
//   //     discount: currentDiscount,
//   //     discountAmt: currentDiscountAmt,
//   //       });
//   //       navigate("/order-tracking", { state, replace: true });
//   //     } catch (e) {
//   //       console.error(e);
//   //       showToast(
//   //         e.message?.includes("fetch")
//   //           ? "Network error — check connection & retry"
//   //           : e.message || "Order failed",
//   //         "error"
//   //       );
//   //     } finally {
//   //       setLoading(false);
//   //       setLabel("");
//   //     }
//   //   };
// const handleCOD = async () => {
//   localStorage.setItem("userPhone", "");
//   localStorage.setItem("custid", "null");
//   setLoading(true);
//   setLabel("Placing your order…");
//   try {
//     const state = await placeOrder({
//       custId: null,
//       phoneNum: "",
//       payTypeId: 2,
//       paidAmt: 0,
//       payOrdId: "COD",
//       discountedTotal,   // use outer-scope value
//       discount,
//       discountAmt,       // use outer-scope value
//     });
//     navigate("/order-tracking", { state, replace: true });
//   } catch (e) {
//     console.error(e);
//     showToast(
//       e.message?.includes("fetch")
//         ? "Network error — check connection & retry"
//         : e.message || "Order failed",
//       "error"
//     );
//   } finally {
//     setLoading(false);
//     setLabel("");
//   }
// };
//     // ── Guest Razorpay ────────────────────────────────────────────────────────
//     const handleGuestPay = async () => {
//       localStorage.setItem("userPhone", "");
//       localStorage.setItem("custid", "null");
//       setLoading(true);
//       setLabel("Connecting to payment…");
//       try {
//         if (!(await loadRazorpay())) throw new Error("Payment SDK failed to load");
//         setLabel("Creating order…");
//         const ores = await fetch(`${BACKEND}/api/LandingPage/create-order`, {
//           method: "POST",
//           mode: "cors",
//           headers: { "Content-Type": "application/json" },
//           body: JSON.stringify({
//             Amount: Math.round(total * 100),
//             Currency: "INR",
//             CompanyId: localStorage.getItem("compId"),
//             StoreId: localStorage.getItem("StoreId"),
//             Receipt: "ORD-" + Date.now(),
//           }),
//         });
//         if (!ores.ok) throw new Error("Payment init failed");
//         const od = await ores.json();
//         setLabel("Waiting for payment…");
//         if (isIOSDevice()) {
//   // ── iOS only: show popup and wait for user to tap Continue ──
//   setShowIOSInstruction(true);
//   await new Promise((resolve) => {
//     iosContinueResolveRef.current = resolve;
//   });
//   setShowIOSInstruction(false);
// }
//         // const pr = await new Promise((res, rej) => {
//         //   const rzp = new window.Razorpay({
//         //     key: od.keyId,
//         //     amount: od.amount,
//         //     currency: "INR",
//         //     order_id: od.orderId,
//         //     name: storeName,
//         //     description: "Food Order",
//         //     theme: { color: "#c8102e" },
//         //     handler: res,
//         //     modal: { ondismiss: () => rej(new Error("Payment cancelled")) },
//         //   });
//         //   rzp.on("payment.failed", (r) => rej(r.error));
//         //   rzp.open();
//         // });
//         const pr = await new Promise((res, rej) => {
//   const rzp = new window.Razorpay({
//     key: od.keyId,
//     amount: od.amount,
//     currency: "INR",
//     order_id: od.orderId,
//     name: storeName,
//     description: "Food Order",
//     prefill: { contact: phone },
//     theme: { color: "#c8102e" },
//     handler: res,
//     modal: { ondismiss: () => rej(new Error("Payment cancelled")) },
//   });
//   rzp.on("payment.failed", (r) => rej(r.error));
//   rzp.open();
// });
//         setLabel("Verifying payment…");
//         const vr = await fetch(`${BACKEND}/api/LandingPage/verify`, {
//           method: "POST",
//           mode: "cors",
//           headers: { "Content-Type": "application/json" },
//           body: JSON.stringify({
//             RazorpayOrderId: od.orderId,
//             RazorpayPaymentId: pr.razorpay_payment_id,
//             RazorpaySignature: pr.razorpay_signature,
//           }),
//         });
//         const v = await vr.json();
//         if (!v.success) throw new Error("Payment verification failed");
//         setLabel("Placing your order…");
//         const state = await placeOrder({
//           custId: null,
//   phoneNum: "",
//   payTypeId: 1,
//   paidAmt: discountedTotal,
//   payOrdId: od.orderId,
//   discountedTotal,
//   discount,
//   discountAmt,
//         });
//         navigate("/order-tracking", { state, replace: true });
//       } catch (e) {
//         console.error(e);
//         if (e.message !== "Payment cancelled")
//           showToast(e.message || "Something went wrong", "error");
//       } finally {
//         setLoading(false);
//         setLabel("");
//       }
//     };

//     // ── Razorpay with phone number ────────────────────────────────────────────
//     const handlePay = async () => {
//       if (!isValidIndianPhone(phone)) {
//         showToast(
//           "Enter a valid 10-digit Indian mobile number starting with 6, 7, 8, or 9"
//         );
//         return;
//       }
//       localStorage.setItem("userPhone", phone);
//       setLoading(true);
//       setLabel("Connecting to payment…");
//       try {
//         let custId = null;
//         try {
//           const cr = await saveCustomer(phone, localStorage.getItem("StoreId"));
//           if (cr?.custid) {
//             localStorage.setItem("custid", cr.custid);
//             custId = cr.custid;
//           }
//         } catch (_) {}
//         if (!(await loadRazorpay())) throw new Error("Please check your internet connection and try again");
//         setLabel("Creating order…");
//         const ores = await fetch(`${BACKEND}/api/LandingPage/create-order`, {
//           method: "POST",
//           mode: "cors",
//           headers: { "Content-Type": "application/json" },
//           body: JSON.stringify({
//             Amount: Math.round(discountedTotal * 100),
//             Currency: "INR",
//             CompanyId: localStorage.getItem("compId"),
//             StoreId: localStorage.getItem("StoreId"),
//             Receipt: "ORD-" + Date.now(),
//           }),
//         });
//         if (!ores.ok) throw new Error("Payment init failed");
//         const od = await ores.json();
//         setLabel("Waiting for payment…");
//         if (isIOSDevice()) {
//   // ── iOS only: show popup and wait for user to tap Continue ──
//   setShowIOSInstruction(true);
//   await new Promise((resolve) => {
//     iosContinueResolveRef.current = resolve;
//   });
//   setShowIOSInstruction(false);
// }
//         // const pr = await new Promise((res, rej) => {
//         //   const rzp = new window.Razorpay({
//         //     key: od.keyId,
//         //     amount: od.amount,
//         //     currency: "INR",
//         //     order_id: od.orderId,
//         //     name: storeName,
//         //     description: "Food Order",
//         //     prefill: { contact: phone },
//         //     theme: { color: "#c8102e" },
//         //     handler: res,
//         //     modal: { ondismiss: () => rej(new Error("Payment cancelled")) },
//         //   });
//         //   rzp.on("payment.failed", (r) => rej(r.error));
//         //   rzp.open();
//         // });
//         const pr = await new Promise((res, rej) => {
//   const rzp = new window.Razorpay({
//     key: od.keyId,
//     amount: od.amount,
//     currency: "INR",
//     order_id: od.orderId,
//     name: storeName,
//     description: "Food Order",
//     prefill: { contact: phone },
//     theme: { color: "#c8102e" },
//     handler: res,
//     modal: { ondismiss: () => rej(new Error("Payment cancelled")) },
//   });
//   rzp.on("payment.failed", (r) => rej(r.error));
//   rzp.open();
// });
//         setLabel("Verifying payment…");
//         const vr = await fetch(`${BACKEND}/api/LandingPage/verify`, {
//           method: "POST",
//           mode: "cors",
//           headers: { "Content-Type": "application/json" },
//           body: JSON.stringify({
//             RazorpayOrderId: od.orderId,
//             RazorpayPaymentId: pr.razorpay_payment_id,
//             RazorpaySignature: pr.razorpay_signature,
//           }),
//         });
//         const v = await vr.json();
//         if (!v.success) throw new Error("Payment verification failed");
//         setLabel("Placing your order…");
//         const state = await placeOrder({
//            custId,
//   phoneNum: phone,
//   payTypeId: 1,
//   paidAmt: discountedTotal,
//   payOrdId: od.orderId,
//   discountedTotal,
//   discount,
//   discountAmt,
//         });
//         navigate("/order-tracking", { state, replace: true });
//       } catch (e) {
//         console.error(e);
//         if (e.message !== "Payment cancelled")
//           showToast(e.message || "Something went wrong", "error");
//       } finally {
//         setLoading(false);
//         setLabel("");
//       }
//     };
// // useEffect(() => {
// //   const storedCart = JSON.parse(localStorage.getItem("cart") || "[]");
// //   if (storedCart.length === 0) {
// //     navigate("/", { replace: true });
// //   }
// // }, []);
// // useEffect(() => {
// //   const storedCart = JSON.parse(localStorage.getItem("cart") || "[]");
// //   if (storedCart.length === 0) {
// //     navigate("/", { replace: true });
// //     return;
// //   }
// //   const storeId = localStorage.getItem("StoreId");
// //   if (storeId) {
// //     getStoreSeries(storeId)
// //       .then((res) => {
// //         console.log("getStoreSeries response:", res); // ← ADD THIS
// //         setSeries(res);
// //         // Check all possible paths the discount might be on
// //         const disc = res?.discount ?? res?.Discount ?? res?.data?.discount ?? 0;
// //         console.log("Resolved discount:", disc); // ← AND THIS
// //         if (disc > 0) setDiscount(disc);
// //       })
// //       .catch((err) => {
// //         console.error("getStoreSeries failed:", err); // ← AND THIS
// //       });
// //   }
// // }, []);
// useEffect(() => {
//   const storedCart = JSON.parse(localStorage.getItem("cart") || "[]");
//   if (storedCart.length === 0) {
//     navigate("/", { replace: true });
//   }
// }, [navigate]);
// useEffect(() => {
//   const onVisible = () => {
//     if (document.visibilityState === "visible") setShowIOSInstruction(false);
//   };
//   document.addEventListener("visibilitychange", onVisible);
//   return () => document.removeEventListener("visibilitychange", onVisible);
// }, []);
// // useEffect(() => {
// //   if (!loading) return;

// //   // Push dummy state
// //   window.history.pushState(null, "", window.location.href);

// //   const block = (e) => {
// //     window.history.pushState(null, "", window.location.href);
// //   };

// //   window.addEventListener("popstate", block);

// //   // Mobile specific - prevent touch back gesture
// //   const preventTouch = (e) => {
// //     if (e.touches[0].clientX < 30) { // left edge swipe = back gesture
// //       e.preventDefault();
// //     }
// //   };

// //   document.addEventListener("touchstart", preventTouch, { passive: false });

// //   return () => {
// //     window.removeEventListener("popstate", block);
// //     document.removeEventListener("touchstart", preventTouch);
// //   };
// // }, [loading]);
// // useEffect(() => {
// //   if (!loading) return;

// //   // Push a guard entry as soon as loading starts
// //   window.history.pushState({ blocking: true }, "", window.location.href);

// //   const block = () => {
// //     // Re-push immediately so the URL/history position never actually changes
// //     window.history.pushState({ blocking: true }, "", window.location.href);
// //   };

// //   window.addEventListener("popstate", block);

// //   // Also block page close/refresh attempts during save
// //   const blockUnload = (e) => {
// //     e.preventDefault();
// //     e.returnValue = "";
// //   };
// //   window.addEventListener("beforeunload", blockUnload);

// //   return () => {
// //     window.removeEventListener("popstate", block);
// //     window.removeEventListener("beforeunload", blockUnload);
// //   };
// // }, [loading]);
// // ── HARD LOCK: back button is illegal during any payment-critical state ──
// useEffect(() => {
//   const isCriticalState = loading; // true from click → until placeOrder() finishes

//   if (!isCriticalState) return;

//   // Push multiple guard entries so even fast repeated back-taps can't escape
//   window.history.pushState({ locked: true }, "", window.location.href);

//   const block = (e) => {
//     // Re-assert immediately — no delay, no gap where back could succeed
//     window.history.pushState({ locked: true }, "", window.location.href);
//     showToast("Please wait — payment is being processed. Do not go back.", "error");
//   };

//   window.addEventListener("popstate", block);

//   // Block hardware back gesture (Android) and edge-swipe (iOS)
//   const preventEdgeSwipe = (e) => {
//     if (e.touches[0].clientX < 30 || e.touches[0].clientX > window.innerWidth - 30) {
//       e.preventDefault();
//     }
//   };
//   document.addEventListener("touchstart", preventEdgeSwipe, { passive: false });

//   // Block tab close / refresh
//   const blockUnload = (e) => { e.preventDefault(); e.returnValue = ""; };
//   window.addEventListener("beforeunload", blockUnload);

//   return () => {
//     window.removeEventListener("popstate", block);
//     document.removeEventListener("touchstart", preventEdgeSwipe);
//     window.removeEventListener("beforeunload", blockUnload);
//   };
// }, [loading]);
//     return (
//       <div className="pp-root">
//         {/* ── Loading overlay ─────────────────────────────────────────────── */}
//         {loading && (
//           <div
//             style={{
//               position: "fixed", inset: 0, background: "rgba(245,240,235,0.96)",
//               display: "flex", alignItems: "center", justifyContent: "center",
//               zIndex: 999, flexDirection: "column", gap: 18,
//             }}
//           >
//             {Logo && Logo !== "null" ? (
//               <div style={{ position: "relative", width: 84, height: 84 }}>
//                 <div
//                   style={{
//                     position: "absolute", inset: 0, borderRadius: "50%",
//                     border: "3px solid #e8e0d8", borderTop: "3px solid #c8102e",
//                     animation: "pp-spin 0.85s linear infinite",
//                   }}
//                 />
//                 <img
//                   src={Logo}
//                   alt=""
//                   style={{
//                     position: "absolute", inset: 7,
//                     width: "calc(100% - 14px)", height: "calc(100% - 14px)",
//                     borderRadius: "50%", objectFit: "cover",
//                   }}
//                 />
//               </div>
//             ) : (
//               <div
//                 style={{
//                   width: 56, height: 56, border: "4px solid #e8e0d8",
//                   borderTop: "4px solid #c8102e", borderRadius: "50%",
//                   animation: "pp-spin 0.8s linear infinite",
//                 }}
//               />
//             )}
//             <span style={{ fontSize: 15, color: "#4a4a4a", fontWeight: 600 }}>
//               {label || "Please wait…"}
//             </span>
//           </div>
//         )}

//         {/* ── Toast ───────────────────────────────────────────────────────── */}
//         {toast && (
//           <div
//             className="pp-toast"
//             style={{
//               background: toast.type === "error" ? "#fdecea" : "#e8f5e9",
//               color: toast.type === "error" ? "#9b0d22" : "#1b5e20",
//               border: `1px solid ${toast.type === "error" ? "#f5c6c6" : "#a5d6a7"}`,
//               boxShadow: "0 4px 20px rgba(0,0,0,0.10)",
//             }}
//           >
//             {toast.msg}
//           </div>
//         )}

//         {/* ── Header ──────────────────────────────────────────────────────── */}
//         <div
//           style={{
//             width: "100%", background: "#1a1a1a", height: 72, display: "flex",
//             alignItems: "center", padding: "0 16px", gap: 12,
//             position: "sticky", top: 0, zIndex: 10,
//           }}
//         >
//           <button
//             onClick={() => {
//               localStorage.removeItem("custid");
//               localStorage.removeItem("userPhone");
//              navigate("/cart", { replace: true }); 
//             }}
//             style={{
//               width: "44px", height: "44px", borderRadius: "50%",
//               background: "rgba(255,255,255,0.08)",
//               border: "1px solid rgba(212,175,55,0.3)",
//               color: "#d4af37", display: "flex", alignItems: "center",
//               justifyContent: "center", cursor: "pointer", fontSize: "20px",
//               fontWeight: "400", transition: "all 0.3s cubic-bezier(0.4,0,0.2,1)",
//               backdropFilter: "blur(10px)",
//             }}
//           >
//             <svg width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2.5" strokeLinecap="round" strokeLinejoin="round">
//     <polyline points="15 18 9 12 15 6" />
//   </svg>
//           </button>
//           <span style={{ color: "#fff", fontSize: 15, fontWeight: 700, flex: 1 }}>
//             {storeName}
//           </span>
//           <span
//             style={{
//               background: "#c8102e", color: "#fff", fontSize: 10, fontWeight: 700,
//               padding: "3px 10px", borderRadius: 99, letterSpacing: 0.5,
//             }}
//           >
//             CHECKOUT
//           </span>
//         </div>

//         {/* ── Body ────────────────────────────────────────────────────────── */}
//         <div   className="pp-body"
//           style={{
//             width: "100%", maxWidth: 420, padding: "20px 16px",
//             display: "flex", flexDirection: "column", gap: 14,
//           }}
//         >
//           {/* Total card */}
//          <div
//   style={{
//     background: "rgb(123 4 4)", borderRadius: 20,
//     padding: "15px 20px", textAlign: "center",
//   }}
// >
//   <p style={{ fontSize: 11, color: "#fff", textTransform: "uppercase", letterSpacing: 1.5, margin: "0 0 4px" }}>
//     Total to pay (inc. taxes)
//   </p>

//   {/* {discount > 0 && (
//     <div style={{ display: "flex", alignItems: "center", justifyContent: "center", gap: 10, marginBottom: 6 }}>
//       <span style={{ fontSize: 28, color: "rgba(255,255,255,0.5)", textDecoration: "line-through", fontWeight: 700 }}>
//         ₹{parseFloat(total).toFixed(2)}
//       </span>
//       <span style={{ background: "#16a34a", color: "#fff", fontSize: 11, fontWeight: 700, padding: "3px 10px", borderRadius: 99, letterSpacing: 0.5 }}>
//         {discount}% OFF
//       </span>
//     </div>
//   )} */}
// {discountAmt > 0 && (
//   <div style={{ display: "flex", alignItems: "center", justifyContent: "center", gap: 10, marginBottom: 6 }}>
//     <span style={{ fontSize: 28, color: "rgba(255,255,255,0.5)", textDecoration: "line-through", fontWeight: 700 }}>
//       ₹{parseFloat(total).toFixed(2)}
//     </span>
//     <span style={{ background: "#16a34a", color: "#fff", fontSize: 11, fontWeight: 700, padding: "3px 10px", borderRadius: 99, letterSpacing: 0.5 }}>
//       {discount}% OFF
//     </span>
//   </div>
// )}
// {/* <div style={{ display: "flex", alignItems: "center", justifyContent: "center", gap: 8, margin: "0 0 4px" }}>
//   <p style={{ fontSize: 46, fontWeight: 800, color: "#fff", margin: 0, letterSpacing: -1 }}>
//     ₹{discountedTotal.toFixed(2)}
//   </p>
//   {Math.abs(roundOffDiff) > 0.001 && (
//     <RoundOffBadge diff={roundOffDiff} />
//   )}
// </div> */}
// <div style={{ display: "flex", alignItems: "center", justifyContent: "center", gap: 8, margin: "0 0 4px" }}>
//   <p style={{ fontSize: 46, fontWeight: 800, color: "#fff", margin: 0, letterSpacing: -1 }}>
//     ₹{discountedTotal.toFixed(2)}
//   </p>
//   {Math.abs(roundOffDiff) > 0.001 && (
//     <RoundOffBadge diff={roundOffDiff} />
//   )}
// </div>
//   {/* {discount > 0 && (
//     <div style={{ display: "flex", alignItems: "center", justifyContent: "center", gap: 6, marginTop: 6 }}>
//       <div style={{ width: 6, height: 6, borderRadius: "50%", background: "#4ade80" }} />
//       <span style={{ fontSize: 12, color: "#a7f3d0", fontWeight: 500 }}>
//         You save ₹{discountAmt.toFixed(2)}
//       </span>
//     </div>
//   )} */}

//   {discountAmt > 0 && (
//   <div style={{ display: "flex", alignItems: "center", justifyContent: "center", gap: 6, marginTop: 6 }}>
//     <div style={{ width: 6, height: 6, borderRadius: "50%", background: "#4ade80" }} />
//     <span style={{ fontSize: 12, color: "#a7f3d0", fontWeight: 500 }}>
//       You save ₹{discountAmt.toFixed(2)}
//     </span>
//   </div>
// )}
// </div>

//           {/* Payment card */}
//           <div className="pp-card">
//             {/* <p style={{ fontSize: 13, fontWeight: 700, color: "#1a1a1a", marginBottom: 4 }}>
//               Pay online via Razorpay
//             </p> */}
//             <p style={{ fontSize: 12, color: "#888", marginBottom: 16 }}>
//               Enter your mobile number
//             </p>

//             {/* Phone input */}
//             <div
//               className="pp-input-row"
//               style={{
//                 marginBottom: phoneError ? 6 : 10,
//                 borderColor: phoneError ? "#e53e3e" : undefined,
//               }}
//             >
//               <span style={{ fontSize: 14, fontWeight: 700, color: "#888" }}>+91</span>
//               <div style={{ width: 1, height: 24, background: "#e8e0d8" }} />
//                <div style={{ position: "relative", flex: 1, display: "flex", alignItems:"center" }}>
//               {/* <input
//                 type="tel"
//                 inputMode="numeric"
//                 pattern="[0-9]*"
//                 maxLength="10"
//                 value={phone}
//                 onChange={handlePhoneChange}
//                 placeholder="Mobile number"
//                 autoFocus
//                 style={{ width: "100%", paddingRight: phoneValid ? 30 : 0 }}
//               /> */}
//               <input
//   type="tel"
//   inputMode="numeric"
//   pattern="[0-9]*"
//   maxLength="10"
//   value={phone}
//   onChange={handlePhoneChange}
//   placeholder="Mobile number"
//   autoFocus
//   onFocus={(e) => {
//     setTimeout(() => {
//       e.target.scrollIntoView({ behavior: "smooth", block: "center" });
//     }, 300); // wait for keyboard animation
//   }}
//   style={{ width: "100%", paddingRight: phoneValid ? 30 : 0 }}
// />
//               {phoneValid && (
//                 <div
//                   style={{
//                     width: 22, height: 22, borderRadius: "50%", background: "#16a34a",
//                     display: "flex", alignItems: "center", justifyContent: "center",
//                     flexShrink: 0,
//                   }}
//                 >
//                   <svg width="11" height="11" viewBox="0 0 12 12" fill="none">
//                     <path
//                       d="M2 6l3 3 5-5"
//                       stroke="#fff"
//                       strokeWidth="2"
//                       strokeLinecap="round"
//                       strokeLinejoin="round"
//                     />
//                   </svg>
//                 </div>
//               )}
//             </div>
//             </div>

//             {phoneError && (
//               <p style={{ fontSize: 11, color: "#e53e3e", margin: "0 0 10px", fontWeight: 500 }}>
//                 ⚠ {phoneError}
//               </p>
//             )}

//             {/* Dot progress */}
//             <div style={{ display: "flex", gap: 5, marginBottom: 18 }}>
//               {Array.from({ length: 10 }, (_, i) => (
//                 <div key={i} className={`pp-dot${i < phone.length ? " on" : ""}`} />
//               ))}
//             </div>

//             {/* Pay with phone */}
//             <button
//               className="pp-btn"
//               onClick={handlePay}
//               disabled={loading || !phoneValid}
//               style={{
//                 background: phoneValid && !loading ? "#c8102e" : "#e8e0d8",
//                 color: phoneValid && !loading ? "#fff" : "#aaa",
//                 border: "none",
//                 marginBottom: 10,
//               }}
//             >
//               {loading && label ? (
//                 <>
//                   <span className="pp-spinner" />
//                   {label}
//                 </>
//               ) : !phoneValid ? (
//                 "Enter valid number to pay online"
//               ) : (
//                 <>
//   Pay ₹{discountedTotal.toFixed(0)}
// <svg
//   width="18"
//   height="18"
//   viewBox="0 0 24 24"
//   fill="none"
//   stroke="currentColor"
//   strokeWidth="4"
//   strokeLinecap="round"
//   strokeLinejoin="round"
// >
//   <polyline points="9 18 15 12 9 6" />
// </svg>
// </>
//               )}
//             </button>

//             {/* Guest pay */}
//             {/* <button
//               className="pp-btn"
//               onClick={handleGuestPay}
//               disabled={loading}
//               style={{
//                 background: "#fff4f6",
//                 border: "1.5px solid #f5c6c6",
//                 color: "#c8102e",
//                 fontWeight: 700,
//                 marginBottom: 14,
//               }}
//             >
//               <svg width="16" height="16" viewBox="0 0 16 16" fill="none">
//                 <circle cx="8" cy="5" r="3" stroke="#c8102e" strokeWidth="1.4" />
//                 <path
//                   d="M2 14c0-3.314 2.686-5 6-5s6 1.686 6 5"
//                   stroke="#c8102e"
//                   strokeWidth="1.4"
//                   strokeLinecap="round"
//                 />
//               </svg>
//               Continue as Guest 
//             </button> */}

//             {/* Divider */}
//             {/* <div
//               style={{
//                 display: "flex", alignItems: "center", gap: 10, margin: "0 0 14px",
//               }}
//             >
//               <div style={{ flex: 1, height: 1, background: "#f0ebe5" }} />
//               <span style={{ fontSize: 12, color: "#bbb", whiteSpace: "nowrap" }}>
//                 or 
//               </span>
//               <div style={{ flex: 1, height: 1, background: "#f0ebe5" }} />
//             </div> */}

//             {/* Pay at counter */}
//             {/* <button
//               className="pp-btn"
//               onClick={handleCOD}
//               disabled={loading}
//               style={{
//                 background: "#fff",
//                 border: "1.5px solid #e8e0d8",
//                 color: "#1a1a1a",
//               }}
//             >
//               <svg width="16" height="16" viewBox="0 0 16 16" fill="none">
//                 <rect x="1" y="3" width="14" height="10" rx="2" stroke="#4a4a4a" strokeWidth="1.4" />
//                 <path
//                   d="M1 7h14M5 10.5h2M9 10.5h2"
//                   stroke="#4a4a4a"
//                   strokeWidth="1.4"
//                   strokeLinecap="round"
//                 />
//               </svg>
//               Skip Payment
//             </button> */}
//           </div>
//         </div>

//         {showIOSInstruction && (
//   <div
//     style={{
//       position: "fixed", inset: 0, background: "rgba(0,0,0,0.55)",
//       display: "flex", alignItems: "center", justifyContent: "center",
//       zIndex: 1500, padding: 20,
//     }}
//   >
//     <div
//       style={{
//         background: "#fff", borderRadius: 16, padding: 24,
//         maxWidth: 320, textAlign: "center",
//       }}
//     >
//       <p style={{ fontSize: 15, fontWeight: 700, color: "#1a1a1a", marginBottom: 8 }}>
//         After paying in your UPI app
//       </p>
//       <p style={{ fontSize: 13, color: "#555", marginBottom: 18, lineHeight: 1.5 }}>
//         Please switch back to this browser tab to see your order confirmation.
//       </p>
//       <button
//   className="pp-btn"
//   onClick={() => {
//     if (iosContinueResolveRef.current) {
//       iosContinueResolveRef.current();
//       iosContinueResolveRef.current = null;
//     }
//   }}
//   style={{ background: "#c8102e", color: "#fff", border: "none" }}
// >
//   Continue to Pay
// </button>
//     </div>
//   </div>
// )}
//       </div>
//     );
//   }


import React, { useState, useEffect } from "react";
import { useNavigate, useLocation } from "react-router-dom";
import {
  saveCustomer,
  getorderno,
  SaveSosOrder,
  getStoreSeries,
  downloadReceipt,
} from "../api/service";

// ── Load Razorpay SDK ─────────────────────────────────────────────────────
function loadRazorpay() {
  return new Promise((resolve) => {
    if (window.Razorpay) return resolve(true);
    const s = document.createElement("script");
    s.src = "https://checkout.razorpay.com/v1/checkout.js";
    s.onload = () => resolve(true);
    s.onerror = () => resolve(false);
    document.body.appendChild(s);
  });
}
function loadScript(src, globalKey) {
  return new Promise((resolve, reject) => {
    if (window[globalKey]) return resolve(window[globalKey]);
    const s = document.createElement("script");
    s.src = src;
    s.onload = () => resolve(window[globalKey]);
    s.onerror = () => reject(new Error(`Failed to load ${src}`));
    document.head.appendChild(s);
  });
}
function truncate2(n) {
  return Math.floor(n * 100) / 100;
}
function round2(n) {
  return Math.round((n + Number.EPSILON) * 100) / 100;
}
function isIOSDevice() {
  return /iPhone|iPad|iPod/.test(navigator.userAgent);
}
function RoundOffBadge({ diff }) {
  const [open, setOpen] = useState(false);
  const sign = diff > 0 ? "+" : "−";
  const abs  = Math.abs(diff).toFixed(2);

  return (
    <div style={{ position: "relative", display: "inline-flex" }}>
      <button
        onClick={() => setOpen(o => !o)}
        onBlur={() => setTimeout(() => setOpen(false), 150)}
        style={{
          width: 20, height: 20, borderRadius: "50%",
          background: "rgba(255,255,255,0.18)",
          border: "1px solid rgba(255,255,255,0.4)",
          color: "#fff", fontSize: 12, fontWeight: 700,
          display: "flex", alignItems: "center", justifyContent: "center",
          cursor: "pointer", padding: 0, lineHeight: 1,
          transform: "translateY(-14px)",
        }}
        aria-label="Round off info"
      >
        i
      </button>
      {open && (
        <div style={{
          position: "absolute", bottom: "calc(100% + 8px)", left: "50%",
          transform: "translateX(-50%)",
          background: "#1a1a1a", color: "#fff",
          fontSize: 11, fontWeight: 500,
          padding: "6px 10px", borderRadius: 8,
          whiteSpace: "nowrap",
          boxShadow: "0 4px 14px rgba(0,0,0,0.3)",
          zIndex: 20,
          animation: "roundOffPop 0.15s ease",
        }}>
          Round off: {sign}₹{abs}
          <div style={{
            position: "absolute", top: "100%", left: "50%",
            transform: "translateX(-50%)",
            width: 0, height: 0,
            borderLeft: "5px solid transparent",
            borderRight: "5px solid transparent",
            borderTop: "5px solid #1a1a1a",
          }} />
        </div>
      )}
    </div>
  );
}
function buildReceiptNode(tracking, storeName, logoUrl) {
  const {
    invoiceNo, orderNo, total, items = [],
    orderType, paymentType, placedAt,
    discount = 0, discountAmt = 0,
    discountedTotal
  } = tracking;

  const totalAmt = Math.round(
    discountAmt > 0 ? (discountedTotal ?? total) : total
  );
  const t1  = parseFloat(total) || 0;
  const subtotal  = items.reduce((s, i) => s + parseFloat(i.SubTotal || 0), 0);
  const tax       = Math.max(0, t1 - subtotal);
  const Receipttax = items.reduce((s, i) => {
    const pct = (parseFloat(i.Tax1) || 0) + (parseFloat(i.Tax2) || 0);
    return s + (parseFloat(i.SubTotal || 0) * pct) / 100;
  }, 0);

  const cgstTotal = items.reduce((s, i) => {
    const pct = parseFloat(i.Tax1) || 0;
    return s + (parseFloat(i.SubTotal || 0) * pct) / 100;
  }, 0);

  const sgstTotal = items.reduce((s, i) => {
    const pct = parseFloat(i.Tax2) || 0;
    return s + (parseFloat(i.SubTotal || 0) * pct) / 100;
  }, 0);

  const isPaid    = paymentType === "Online";

  const placedMs  = typeof placedAt === "number" ? placedAt : parseInt(placedAt) || 0;
  const dt        = placedMs > 0 ? new Date(placedMs) : new Date();

  const fmtDate   = dt.toLocaleDateString("en-IN", { day:"2-digit", month:"short", year:"numeric" });
  const fmtTime   = dt.toLocaleTimeString("en-IN", { hour:"2-digit", minute:"2-digit", hour12:true }).toUpperCase();

  const RED       = "#C8102E";
  const RED_LIGHT = "#FFF5F5";
  const RED_MID   = "#FFE0E0";
  const DARK      = "#1A1A1A";
  const GRAY      = "#888888";
  const GRAY_LT   = "#AAAAAA";
  const BORDER    = "#EEEEEE";
  const BG        = "#FAFAFA";
  const WHITE     = "#FFFFFF";

  const w = document.createElement("div");
  w.style.cssText = `
    font-family: Arial, sans-serif;
    font-size: 11px;
    color: ${DARK};
    background: ${WHITE};
    width: 397px;
    box-sizing: border-box;
  `;

  w.innerHTML = `
    <style>
      .rcpt * { box-sizing: border-box; margin: 0; padding: 0; }
      .rcpt    { width: 397px; background: ${WHITE}; font-family: Arial, sans-serif; }
    </style>

    <div class="rcpt">
      <div style="background:${WHITE}; padding:14px;">
        <div style="display:flex; align-items:flex-start; justify-content:space-between;">
          <div>
            <div style="font-size:9px; color:${GRAY_LT}; text-transform:uppercase; letter-spacing:1px;">INVOICE</div>
            <div style="font-size:18px; font-weight:700; color:${DARK}; margin-top:3px; line-height:1.1;">${storeName || "Restaurant"}</div>
          </div>
          <div id="logo-slot" style="width:50px; height:50px; flex-shrink:0;"></div>
        </div>

        <div style="margin-top:14px; background:${RED_LIGHT}; border:1px solid ${RED_MID}; padding:12px; display:flex; align-items:flex-start; justify-content:space-between;">
          <div>
            <div style="font-size:8px; font-weight:700; color:${RED}; text-transform:uppercase; letter-spacing:1px;">YOUR TOKEN</div>
            <div style="font-size:40px; font-weight:700; color:${RED}; line-height:1; margin-top:2px;">${orderNo || "—"}</div>
          </div>
          <div style="text-align:right;">
            <div style="font-size:8px; color:${GRAY_LT}; text-transform:uppercase; letter-spacing:1px;">TOTAL</div>
            <div style="font-size:26px; font-weight:700; color:${DARK}; margin-top:2px;">₹${totalAmt.toFixed(2)}</div>
            <div style="font-size:9px; margin-top:4px; color:${isPaid ? "#16A34A" : GRAY};">
              ${isPaid ? "Paid online" : "Pay at counter"}
            </div>
          </div>
        </div>

        <div style="margin-top:8px; display:flex; gap:3px;">
          ${chip("DATE",  fmtDate,  BG, BORDER, GRAY_LT, DARK)}
          ${chip("TIME",  fmtTime,  BG, BORDER, GRAY_LT, DARK)}
          ${chip("TYPE",  orderType || "Take Away", BG, BORDER, GRAY_LT, DARK)}
        </div>
      </div>

      <div style="background:${WHITE}; padding:0 14px;">
        <div style="border-bottom:1px solid ${BORDER}; padding-bottom:5px; font-size:8px; color:${GRAY_LT}; text-transform:uppercase; letter-spacing:1px;">
          ORDER DETAILS
        </div>

        ${items.map(item => {
            const price   = parseFloat(item.Price) || 0;
            const taxPct  = (parseFloat(item.Tax1) || 0) + (parseFloat(item.Tax2) || 0);
            const itemPriceWithoutTax = round2(price / (1 + taxPct / 100));
            const lineTotal = (parseFloat(item.SubTotal) || 0) * (parseInt(item.Quantity) || 1);
            return `
            <div style="display:flex; justify-content:space-between; align-items:center;
                        border-bottom:1px solid ${BORDER}; padding:8px 0;">
              <div>
                <div style="font-size:11px; font-weight:700; color:${DARK};">${item.ProductName || "Item"}</div>
                <div style="font-size:8px; color:${GRAY_LT}; margin-top:2px;">
                  ×${item.Quantity}&nbsp;&nbsp;·&nbsp;&nbsp;₹${(itemPriceWithoutTax || 0).toFixed(2)}/each
                </div>
              </div>
              <div style="font-size:12px; font-weight:700; color:${RED}; flex-shrink:0; padding-left:8px;">
                ₹${item.SubTotal.toFixed(2)}
              </div>
            </div>
          `;
        }).join("")}
      </div>

      <div style="background:${WHITE}; padding:10px 14px 6px;">
        ${trow("Subtotal", `₹${subtotal.toFixed(2)}`, false, GRAY, GRAY)}
        ${trow("CGST", `₹${truncate2(cgstTotal).toFixed(2)}`, false, GRAY, GRAY)}
        ${trow("SGST", `₹${truncate2(sgstTotal).toFixed(2)}`, false, GRAY, GRAY)}
        ${discountAmt > 0 ? trow(`Discount (${discount}%)`, `-₹${parseFloat(discountAmt).toFixed(2)}`, false, "#16A34A", "#16A34A") : ""}
        <div style="border-top:1px solid ${BORDER}; margin:8px 0 6px;"></div>
        ${trow("Total Paid", `₹${totalAmt.toFixed(2)}`, true, DARK, RED)}
      </div>

      <div style="background:${DARK}; padding:9px 14px; display:flex; justify-content:space-between; align-items:center;">
        <span style="font-size:9px; color:${WHITE};">${invoiceNo || "—"}</span>
        <span style="font-size:9px; color:${WHITE};">Receipt by BizDom Solutions</span>
      </div>

      <div style="background:${RED}; padding:14px; text-align:center;">
        <div style="font-size:13px; font-weight:700; color:${WHITE};">Thank&nbsp;you for your order!</div>
        <div style="font-size:9px; color:#FFCCCC; margin-top:4px; text-align:center;">
          Show token ${orderNo} at the counter to collect
        </div>
      </div>
    </div>
  `;

  const logoSlot = w.querySelector("#logo-slot");
  if (logoUrl && logoUrl.startsWith("http")) {
    const img = document.createElement("img");
    img.crossOrigin = "anonymous";
    img.src = logoUrl;
    img.style.cssText = "width:50px;height:50px;object-fit:contain;";
    logoSlot.appendChild(img);
  } else {
    logoSlot.style.cssText += `background:${RED};display:flex;align-items:center;justify-content:center;`;
    logoSlot.innerHTML = `<span style="font-size:20px;font-weight:700;color:#fff;">${(storeName||"R")[0].toUpperCase()}</span>`;
  }

  return w;
}
function chip(label, value, bg, border, labelColor, valueColor) {
  return `
    <div style="flex:1; background:${bg}; border:1px solid ${border}; padding:6px 4px; text-align:center;">
      <div style="font-size:7px; color:${labelColor}; text-transform:uppercase; letter-spacing:0.5px;">${label}</div>
      <div style="font-size:9px; font-weight:700; color:${valueColor}; margin-top:2px;">${value}</div>
    </div>
  `;
}
function trow(label, value, grand, lc, vc) {
  return `
    <div style="display:flex;justify-content:space-between;align-items:center;margin-bottom:${grand?0:4}px;">
      <span style="font-size:${grand?12:10}px; font-weight:${grand?"700":"400"}; color:${lc};">${label}</span>
      <span style="font-size:${grand?14:10}px; font-weight:${grand?"700":"400"}; color:${vc};">${value}</span>
    </div>
  `;
}
function playSuccessSound() {
  try {
    const AudioCtx = window.AudioContext || window.webkitAudioContext;
    if (!AudioCtx) return;
    const ctx = new AudioCtx();

    const run = () => {
      const rvLen = ctx.sampleRate * 2.2;
      const rvBuf = ctx.createBuffer(2, rvLen, ctx.sampleRate);
      for (let c = 0; c < 2; c++) {
        const d = rvBuf.getChannelData(c);
        for (let i = 0; i < rvLen; i++)
          d[i] = (Math.random() * 2 - 1) * Math.pow(1 - i / rvLen, 2.8);
      }
      const rv = ctx.createConvolver();
      rv.buffer = rvBuf;

      const comp = ctx.createDynamicsCompressor();
      comp.threshold.value = -14; comp.knee.value = 10;
      comp.ratio.value = 5; comp.attack.value = 0.002; comp.release.value = 0.20;
      comp.connect(ctx.destination);

      const dry = ctx.createGain(); dry.gain.value = 0.68;
      const wet = ctx.createGain(); wet.gain.value = 0.32;
      dry.connect(comp); rv.connect(wet); wet.connect(comp);

      const pan = v => {
        const p = ctx.createStereoPanner
          ? ctx.createStereoPanner()
          : { pan: { value: 0 }, connect: n => n };
        if (p.pan) p.pan.value = v;
        return p;
      };

      const bell = (freq, t, dur, vol, panV = 0) => {
        [
          { type: "sine",     detune: 0,  mix: 1.00 },
          { type: "triangle", detune: 4,  mix: 0.30 },
          { type: "sine",     detune: -3, mix: 0.18 },
        ].forEach(({ type, detune, mix }) => {
          const osc = ctx.createOscillator();
          const g   = ctx.createGain();
          const p   = pan(panV);
          osc.type = type;
          osc.frequency.value = type === "sine" && detune === -3 ? freq / 2 : freq;
          osc.detune.value = detune;
          const t0 = ctx.currentTime + t;
          g.gain.setValueAtTime(0, t0);
          g.gain.linearRampToValueAtTime(vol * mix,    t0 + 0.010);
          g.gain.setTargetAtTime(vol * mix * 0.50,     t0 + 0.025, 0.055);
          g.gain.exponentialRampToValueAtTime(0.00001, t0 + dur);
          osc.connect(g); g.connect(p);
          if (typeof p.connect === "function" && p !== g) {
            p.connect(dry); p.connect(rv);
          } else {
            g.connect(dry); g.connect(rv);
          }
          osc.start(t0); osc.stop(t0 + dur + 0.12);
        });
      };

      const thud = ctx.createOscillator();
      const tG   = ctx.createGain();
      thud.type  = "sine";
      thud.frequency.setValueAtTime(160, ctx.currentTime);
      thud.frequency.exponentialRampToValueAtTime(38, ctx.currentTime + 0.14);
      tG.gain.setValueAtTime(0.55, ctx.currentTime);
      tG.gain.exponentialRampToValueAtTime(0.00001, ctx.currentTime + 0.20);
      thud.connect(tG); tG.connect(comp);
      thud.start(ctx.currentTime); thud.stop(ctx.currentTime + 0.24);

      const nBuf  = ctx.createBuffer(1, ctx.sampleRate * 0.04, ctx.sampleRate);
      const nD    = nBuf.getChannelData(0);
      for (let i = 0; i < nD.length; i++) nD[i] = Math.random() * 2 - 1;
      const nSrc  = ctx.createBufferSource();
      const nFilt = ctx.createBiquadFilter();
      const nGain = ctx.createGain();
      nSrc.buffer = nBuf; nFilt.type = "bandpass";
      nFilt.frequency.value = 3200; nFilt.Q.value = 0.8;
      nGain.gain.setValueAtTime(0.18, ctx.currentTime);
      nGain.gain.exponentialRampToValueAtTime(0.00001, ctx.currentTime + 0.04);
      nSrc.connect(nFilt); nFilt.connect(nGain); nGain.connect(comp);
      nSrc.start(ctx.currentTime);

      bell(293.66, 0.00, 1.30, 0.52, -0.2);
      bell(369.99, 0.14, 1.15, 0.46,  0.0);
      bell(440.00, 0.27, 1.05, 0.42,  0.2);
      bell(587.33, 0.40, 1.55, 0.38,  0.0);
      bell(739.99, 0.54, 1.80, 0.30,  0.0);

      const gl  = ctx.createOscillator();
      const glG = ctx.createGain();
      gl.type = "sine"; gl.frequency.value = 2349.32;
      glG.gain.setValueAtTime(0, ctx.currentTime + 0.54);
      glG.gain.linearRampToValueAtTime(0.06, ctx.currentTime + 0.58);
      glG.gain.exponentialRampToValueAtTime(0.00001, ctx.currentTime + 1.80);
      gl.connect(glG); glG.connect(dry); glG.connect(rv);
      gl.start(ctx.currentTime + 0.54); gl.stop(ctx.currentTime + 1.90);
    };

    if (ctx.state === "suspended") {
      ctx.resume().then(run).catch(() => {});
    } else {
      run();
    }
  } catch (e) {
    console.warn("Chime error:", e);
  }
}
const PP_CSS = `
  @import url('https://fonts.googleapis.com/css2?family=DM+Sans:wght@400;500;600;700;800&display=swap');
  @keyframes pp-spin  { to { transform:rotate(360deg); } }
  @keyframes pp-rise  { from{opacity:0;transform:translateY(14px)}to{opacity:1;transform:translateY(0)} }
  @keyframes pp-toast { 0%{opacity:0;transform:translateX(-50%) translateY(-10px)} 10%,85%{opacity:1;transform:translateX(-50%) translateY(0)} 100%{opacity:0;transform:translateX(-50%) translateY(-10px)} }
  @keyframes roundOffPop {
    from { opacity: 0; transform: translateX(-50%) translateY(4px); }
    to   { opacity: 1; transform: translateX(-50%) translateY(0); }
  }
  html, body, #root {
    -webkit-text-size-adjust: 100%;
    -moz-text-size-adjust: 100%;
    text-size-adjust: 100%;
  }
  .pp-root{font-family:'DM Sans',system-ui,sans-serif;min-height:100vh;background:#f5f0eb;display:flex;flex-direction:column;align-items:center;overflow-y: auto;}
  .pp-card{background:#fff;border-radius:20px;padding:24px;width:100%;border:0.5px solid #ede8e0;animation:pp-rise 0.35s ease both;}
  .pp-input-row{display:flex;align-items:center;gap:10px;border:2px solid #e8e0d8;border-radius:12px;padding:13px 16px;background:#faf8f4;transition:border-color 0.2s,background 0.2s;}
  .pp-input-row:focus-within{border-color:#c8102e;background:#fff;}
  .pp-input-row input{flex:1;border:none;outline:none;font-size:20px;font-weight:700;background:transparent;color:#1a1a1a;letter-spacing:2px;font-family:'DM Sans',system-ui,sans-serif;}
  .pp-input-row input::placeholder{font-size:14px;font-weight:400;color:#c0b8b0;letter-spacing:0;}
  .pp-btn{width:100%;padding:15px;border-radius:13px;font-size:15px;font-weight:700;cursor:pointer;transition:all 0.15s;font-family:'DM Sans',system-ui,sans-serif;display:flex;align-items:center;justify-content:center;gap:8px;}
  .pp-btn:active:not(:disabled){transform:scale(0.97);}
  .pp-btn:disabled{cursor:not-allowed;}
  .pp-spinner{width:18px;height:18px;border:2.5px solid rgba(255,255,255,0.35);border-top-color:#fff;border-radius:50%;animation:pp-spin 0.7s linear infinite;}
  .pp-toast{position:fixed;top:20px;left:50%;transform:translateX(-50%);padding:11px 20px;border-radius:99px;font-size:13px;font-weight:600;z-index:2000;white-space:nowrap;animation:pp-toast 3.5s ease forwards;}
  .pp-dot{width:9px;height:9px;border-radius:50%;background:#e8e0d8;transition:background 0.2s,transform 0.2s;}
  .pp-dot.on{background:#c8102e;transform:scale(1.15);}
  @media screen and (min-width: 601px) {
    .pp-body { max-width: min(720px, 90vw) !important; width: 100% !important; }
    .pp-card { padding: 32px !important; }
  }
  @media screen and (min-width: 601px) and (orientation: landscape) {
    .pp-body { max-width: min(820px, 86vw) !important; }
  }
`;
if (!document.getElementById("pp-css2")) {
  const el = document.createElement("style");
  el.id = "pp-css2";
  el.textContent = PP_CSS;
  document.head.appendChild(el);
}

const BACKEND = "https://uat-ecom.azurewebsites.net";

async function withRetry(fn, tries = 3) {
  for (let i = 0; i < tries; i++) {
    try {
      return await fn();
    } catch (e) {
      if (i === tries - 1) throw e;
      await new Promise((r) => setTimeout(r, 1000 * (i + 1)));
    }
  }
}

function calcOrder(cart, storeId, discountPercent = 0) {
  let bill = 0, sub = 0, tax = 0;
  const items = [];
  const sharedKotrefid = generateUltraSecureBigInt(storeId);

  cart.forEach((p) => {
    const q = p.quantity || 1,
      m = 1 + ((p.tax1 ?? 0) + (p.tax2 ?? 0)) / 100;
    const rsFull = parseFloat(((p.sosPrice * q) / m).toFixed(2));

    const isDiscountEligible = p.minquantity !== 1;
    const effDiscount = isDiscountEligible ? discountPercent : 0;

    const itemDiscountAmt = parseFloat(((rsFull * effDiscount) / 100).toFixed(2));
    const rs = effDiscount > 0
      ? parseFloat((rsFull - itemDiscountAmt).toFixed(2))
      : rsFull;

    const cg = rs * ((p.tax1 || 0) / 100);
    const sg = rs * ((p.tax2 || 0) / 100);
    bill += p.sosPrice * q;
    sub += rs;
    tax += cg + sg;

    items.push({
      ProductId: p.id,
      ProductName: p.product_Name,
      Quantity: q,
      Price: parseFloat(p.sosPrice.toFixed(2)),
      Tax1: p.tax1,
      Tax2: p.tax2,
      Tax3: 0,
      SubTotal: rs,
      TotalAmount: rsFull,
      ImgUrl: p.product_Imageurl,
      Prod_Desc: p.product_Name,
      isAddon: false,
      Kotrefid: sharedKotrefid,
      DiscountSummary: {
        _type: "discount_summary",
        originalAmount: parseFloat((p.sosPrice * q).toFixed(2)),
        discountPercent: effDiscount,
        discountAmount: parseFloat(((p.sosPrice * q * effDiscount) / 100).toFixed(2)),
        totalAmount: parseFloat(((p.sosPrice * q) - ((p.sosPrice * q * effDiscount) / 100)).toFixed(2)),
      },
    });

    (p.addons || []).forEach((a) => {
      const aq = a.qty || 1,
        am = 1 + ((a.tax1 ?? 0) + (a.tax2 ?? 0)) / 100;
      const as2 = parseFloat(((a.sosPrice * aq) / am).toFixed(2));
      const ac  = (as2 / aq) * ((a.tax1 || 0) / 100) * aq;
      const as3 = (as2 / aq) * ((a.tax2 || 0) / 100) * aq;
      bill += a.sosPrice * aq;
      sub += as2;
      tax += ac + as3;
      items.push({
        ProductId: a.id,
        ProductName: a.name,
        Quantity: aq,
        Price: parseFloat(a.sosPrice.toFixed(2)),
        Tax1: ac,
        Tax2: as3,
        Tax3: 0,
        SubTotal: as2,
        TotalAmount: as2,
        ImgUrl: a.imageurl,
        Prod_Desc: a.name,
        isAddon: false,
        Kotrefid: sharedKotrefid,
      });
    });
  });

  return {
    bill: parseFloat(bill.toFixed(2)),
    sub: parseFloat(sub.toFixed(2)),
    tax: parseFloat(tax.toFixed(5)),
    items,
  };
}

async function pdfBlobToPngBlob(pdfBlob) {
  try {
    const pdfjsLib = await new Promise((resolve, reject) => {
      if (window.pdfjsLib) return resolve(window.pdfjsLib);
      const script = document.createElement("script");
      script.src = "https://cdnjs.cloudflare.com/ajax/libs/pdf.js/3.11.174/pdf.min.js";
      script.onload = () => {
        window.pdfjsLib.GlobalWorkerOptions.workerSrc =
          "https://cdnjs.cloudflare.com/ajax/libs/pdf.js/3.11.174/pdf.worker.min.js";
        resolve(window.pdfjsLib);
      };
      script.onerror = () => reject(new Error("PDF.js failed to load"));
      document.head.appendChild(script);
    });

    const arrayBuffer = await pdfBlob.arrayBuffer();
    const pdf = await pdfjsLib.getDocument({ data: arrayBuffer }).promise;
    const page = await pdf.getPage(1);

    const scale    = 3;
    const viewport = page.getViewport({ scale });
    const canvas   = document.createElement("canvas");
    canvas.width   = viewport.width;
    canvas.height  = viewport.height;

    const ctx = canvas.getContext("2d");
    ctx.fillStyle = "#ffffff";
    ctx.fillRect(0, 0, canvas.width, canvas.height);

    await page.render({ canvasContext: ctx, viewport }).promise;

    return await new Promise((resolve, reject) => {
      canvas.toBlob(
        (blob) => blob ? resolve(blob) : reject(new Error("toBlob failed")),
        "image/png",
        1.0
      );
    });
  } catch (err) {
    console.error("PDF → PNG failed:", err);
    return null;
  }
}
function triggerDownload(blob, filename) {
  const url = URL.createObjectURL(blob);
  const a = document.createElement("a");
  a.href = url;
  a.download = filename;
  a.style.display = "none";
  document.body.appendChild(a);
  a.click();
  document.body.removeChild(a);
  setTimeout(() => URL.revokeObjectURL(url), 5000);
}
function openInNewTab(blob, filename) {
  const url = URL.createObjectURL(blob);
  const win = window.open(url, "_blank");
  if (!win) {
    triggerDownload(blob, filename);
  }
  setTimeout(() => URL.revokeObjectURL(url), 30000);
}

// async function downloadAndSaveReceipt(tracking, storeName, logoUrl) {
//   try {
//     await loadScript(
//       "https://cdnjs.cloudflare.com/ajax/libs/html2canvas/1.4.1/html2canvas.min.js",
//       "html2canvas"
//     );
//     await loadScript(
//       "https://cdnjs.cloudflare.com/ajax/libs/jspdf/2.5.1/jspdf.umd.min.js",
//       "jspdf"
//     );

//     const node = buildReceiptNode(tracking, storeName, logoUrl);
//     node.style.position = "fixed";
//     node.style.top      = "-9999px";
//     node.style.left     = "-9999px";
//     document.body.appendChild(node);

//     const img = node.querySelector("img");
//     if (img) {
//       await new Promise(r => {
//         if (img.complete) return r();
//         img.onload = img.onerror = r;
//         setTimeout(r, 3000);
//       });
//     }

//     const canvas = await window.html2canvas(node, {
//       scale:            3,
//       useCORS:          true,
//       allowTaint:       false,
//       backgroundColor:  "#FFFFFF",
//       logging:          false,
//     });

//     document.body.removeChild(node);

//     const safeName   = (tracking.invoiceNo || "receipt").replace(/\//g, "-");
//     const pngFilename = `receipt-${safeName}.png`;
//     const pdfFilename = `receipt-${safeName}.pdf`;

//     canvas.toBlob(pngBlob => {
//       if (pngBlob) triggerDownload(pngBlob, pngFilename);
//     }, "image/png", 1.0);

//     await new Promise(r => setTimeout(r, 400));

//     const { jsPDF } = window.jspdf;
//     const W_MM  = 105;
//     const H_MM  = (canvas.height / canvas.width) * W_MM;

//     const pdf = new jsPDF({ orientation: "portrait", unit: "mm", format: [W_MM, H_MM] });
//     pdf.addImage(canvas.toDataURL("image/png"), "PNG", 0, 0, W_MM, H_MM);

//     const pdfBlob = pdf.output("blob");
//     await new Promise(r => setTimeout(r, 300));
//     triggerDownload(pdfBlob, pdfFilename);

//     return true;
//   } catch (error) {
//     console.error("Receipt generation error:", error);
//     return false;
//   }
// }
async function downloadAndSaveReceipt(tracking, storeName, logoUrl, setLabel) {
  try {
    setLabel?.("Preparing your receipt…");
    await loadScript("https://cdnjs.cloudflare.com/ajax/libs/html2canvas/1.4.1/html2canvas.min.js", "html2canvas");
    await loadScript("https://cdnjs.cloudflare.com/ajax/libs/jspdf/2.5.1/jspdf.umd.min.js", "jspdf");

    const node = buildReceiptNode(tracking, storeName, logoUrl);
    node.style.position = "fixed";
    node.style.top = "-9999px";
    node.style.left = "-9999px";
    document.body.appendChild(node);

    const img = node.querySelector("img");
    if (img) {
      await new Promise(r => {
        if (img.complete) return r();
        img.onload = img.onerror = r;
        setTimeout(r, 3000);
      });
    }

    setLabel?.("Generating your invoice…");
    const canvas = await window.html2canvas(node, {
      scale: 3, useCORS: true, allowTaint: false, backgroundColor: "#FFFFFF", logging: false,
    });
    document.body.removeChild(node);

    const safeName = (tracking.invoiceNo || "receipt").replace(/\//g, "-");
    const pngFilename = `receipt-${safeName}.png`;
    const pdfFilename = `receipt-${safeName}.pdf`;

    canvas.toBlob(pngBlob => { if (pngBlob) triggerDownload(pngBlob, pngFilename); }, "image/png", 1.0);
    await new Promise(r => setTimeout(r, 400));

    setLabel?.("Saving your receipt…");
    const { jsPDF } = window.jspdf;
    const W_MM = 105;
    const H_MM = (canvas.height / canvas.width) * W_MM;
    const pdf = new jsPDF({ orientation: "portrait", unit: "mm", format: [W_MM, H_MM] });
    pdf.addImage(canvas.toDataURL("image/png"), "PNG", 0, 0, W_MM, H_MM);
    const pdfBlob = pdf.output("blob");
    await new Promise(r => setTimeout(r, 300));
    triggerDownload(pdfBlob, pdfFilename);

    return true;
  } catch (error) {
    console.error("Receipt generation error:", error);
    return false;
  }
}
function generateUltraSecureBigInt(storeId = 1) {
  const timestamp = Math.floor(Date.now() / 1000);
  const arr = new Uint32Array(1);
  crypto.getRandomValues(arr);
  const random = arr[0] % 10000;
  return Number(
    `${timestamp}${storeId
      .toString()
      .padStart(2, "0")}${random
      .toString()
      .padStart(4, "0")}`
  );
}
function computeEligibleDiscountAmt(cartItems, discountPercent) {
  if (!discountPercent || discountPercent <= 0) return 0;
  let amt = 0;
  cartItems.forEach((p) => {
    if (p.minquantity === 1) return;
    const qty = p.quantity || 1;
    amt += ((p.sosPrice || 0) * qty * discountPercent) / 100;
  });
  return parseFloat(amt.toFixed(2));
}

// ── COD ONLY beyond this point: this still hits your existing
//    ExeSosController /save-order-Exesos endpoint directly, unchanged.
//    There's no payment gateway redirect for COD, so there's nothing for
//    the tab to "miss" — the iOS problem only applies to online payment. ──
async function placeOrder({ custId, phoneNum, payTypeId, paidAmt, payOrdId, discountedTotal, discount, discountAmt }) {
  const storeId   = localStorage.getItem("StoreId");
  const CompId    = localStorage.getItem("compId");
  const Macadd    = localStorage.getItem("macAdrs");
  const typeiD    = localStorage.getItem("ordertypeId");
  const orderType = localStorage.getItem("orderType") || "Take Away";
  const cart      = JSON.parse(localStorage.getItem("cart") || "[]");
  const now       = new Date();
  const ds        = now.toLocaleDateString("en-GB").split("/").reverse().join("");

  const or          = await withRetry(() => getorderno(storeId));
  const ordNo       = or.getOrderIndex[0].ordNo || 0;
  const tokenPrefix = "M";
  const ino         = `SOS/D/${ds}/${ordNo}`;
  const token       = `${tokenPrefix}-${String(ordNo).padStart(2, "0")}`;

  const { bill, sub, tax, items } = calcOrder(cart, storeId, discount ?? 0);
  const billamount = Math.round(bill - discountAmt);
  const d = `${now.getFullYear()}-${String(now.getMonth() + 1).padStart(2, "0")}-${String(now.getDate()).padStart(2, "0")}`;
  const t = now.toLocaleTimeString("en-GB", { hour12: false });
  const rawTableName = localStorage.getItem("tableName") || "";
  const tableNameNum = rawTableName.replace(/[^0-9]/g, "");

  const eligibleSubtotalBeforeDiscount = cart.reduce((s, p) => {
    if (p.minquantity === 1) return s;
    return s + (p.sosPrice || 0) * (p.quantity || 1);
  }, 0);

  const effectiveDiscPercent = eligibleSubtotalBeforeDiscount > 0
    ? parseFloat(((discountAmt / eligibleSubtotalBeforeDiscount) * 100).toFixed(2))
    : 0;

  const payload = {
    qrId:            payTypeId === 1 ? payOrdId : new Date().toISOString(),
    PayOrdId:        payOrdId,
    OrderedDate:     d,
    OrderNo:         parseInt(ordNo),
    UserId:          3,
    SourceId:        1,
    StoreId:         parseInt(storeId),
    DeliverySoreId:  parseInt(storeId),
    OrderTypeId:     14,
    PrevStsId:       typeiD,
    Invoiceno:       ino,
    CusId:           parseInt(custId || 0),
    Custname:        "Guest",
    Phoneno:         parseInt(phoneNum || 0),
    DineId:          parseInt(localStorage.getItem("dineTableid")),
    Type:            1,
    Billamount:      billamount,
    TotalAmount:     sub,
    Taxamount:       tax,
    Paidamount:      Math.round(parseFloat(paidAmt)),
    CompanyId:       parseInt(CompId),
    PaymentTypeId:   payTypeId,
    OrderStatusId:   1,
    TransStatusId:   2,
    Tax1:            parseFloat((tax / 2).toFixed(5)),
    Tax2:            parseFloat((tax / 2).toFixed(5)),
    Tax3:            0,
    BillStatusId:    1,
    DiscPercent:     effectiveDiscPercent,
    DiscAmount:      discountAmt ?? 0,
    OrderTime:       t,
    OrderedDateTime: `${d}T${t}`,
    DeliveryTime:    t,
    DeliveryDate:    now.toISOString(),
    DeliveryDateTime:`${d}T${t}`,
    CreatedDateTime: now.toISOString(),
    ModifiedDateTime:now.toISOString(),
    ItmJson:         JSON.stringify(items),
    ChargeJson:      Macadd,
    icr: "M",
    TableName: tableNameNum,
  };

  const res = await withRetry(() => SaveSosOrder(payload));
  if (!res.success) throw new Error("Order save failed — please retry");

  const tracking = {
    invoiceNo:   res.invoiceNo,
    orderNo:    `${tokenPrefix}-${String(res.orderNo).padStart(2, "0")}`,
    total:       bill,
    items,
    orderType,
    paymentType: payTypeId === 1 ? "Online" : "COD",
    paid:        payTypeId === 1,
    placedAt:    Date.now(),
    discount,
    discountAmt,
    discountedTotal,
  };

  localStorage.setItem("lastOrder", JSON.stringify(tracking));

  ["cart", "custid", "userPhone", "lastActiveCategory", "selectedFreeItems", "allowedFreeQty", "tableName"]
    .forEach((k) => localStorage.removeItem(k));

  const storeName = localStorage.getItem("StoreName") || "Restaurant";
  const logoUrl   = localStorage.getItem("logo") || "";

  await downloadAndSaveReceipt(tracking, storeName, logoUrl);
  try { playSuccessSound(); } catch (_) {}

  return tracking;
}

// ════════════════════════════════════════════════════════════════════════
// ONLINE PAYMENT (Razorpay) — this is the part that changed for the iOS
// fix. Order placement for online payments no longer happens purely in
// the browser: /api/Payment/create-order saves the full order draft
// server-side, and /api/Payment/verify (or the webhook, if the tab dies)
// is what actually places the order.
// ════════════════════════════════════════════════════════════════════════

// Mirrors calcOrder()'s pricing so the backend can place the exact same
// order the customer saw on screen, without needing the browser at all.
function buildOrderDraft({ custId, phoneNum, discountAmt, discount }) {
  const storeId = localStorage.getItem("StoreId");
  const CompId  = localStorage.getItem("compId");
  const Macadd  = localStorage.getItem("macAdrs");
  const typeiD  = localStorage.getItem("ordertypeId");
  const cart    = JSON.parse(localStorage.getItem("cart") || "[]");
  const now     = new Date();

  const { bill, sub, tax, items } = calcOrder(cart, storeId, discount ?? 0);
  const billamount = Math.round(bill - discountAmt);

  const d = `${now.getFullYear()}-${String(now.getMonth() + 1).padStart(2, "0")}-${String(now.getDate()).padStart(2, "0")}`;
  const t = now.toLocaleTimeString("en-GB", { hour12: false });
  const rawTableName = localStorage.getItem("tableName") || "";
  const tableNameNum = rawTableName.replace(/[^0-9]/g, "");

  const eligibleSubtotalBeforeDiscount = cart.reduce((s, p) => {
    if (p.minquantity === 1) return s;
    return s + (p.sosPrice || 0) * (p.quantity || 1);
  }, 0);
  const effectiveDiscPercent = eligibleSubtotalBeforeDiscount > 0
    ? parseFloat(((discountAmt / eligibleSubtotalBeforeDiscount) * 100).toFixed(2))
    : 0;

  // OrderNo / Invoiceno / PayOrdId / Paidamount are deliberately omitted —
  // the backend fills OrderNo + Invoiceno atomically inside the stored
  // proc, and PayOrdId + Paidamount only get set once payment actually
  // captures, by /verify or by the webhook — never by the client.
  return {
    UserId: 3,
    SourceId: 1,
    StoreId: parseInt(storeId),
    DeliverySoreId: parseInt(storeId),
    OrderTypeId: 14,
    PrevStsId: typeiD,
    CusId: parseInt(custId || 0),
    Custname: "Guest",
    Phoneno: parseInt(phoneNum || 0),
    DineId: parseInt(localStorage.getItem("dineTableid")),
    Type: 1,
    Billamount: billamount,
    TotalAmount: sub,
    Taxamount: tax,
    CompanyId: parseInt(CompId),
    OrderStatusId: 1,
    TransStatusId: 2,
    Tax1: parseFloat((tax / 2).toFixed(5)),
    Tax2: parseFloat((tax / 2).toFixed(5)),
    Tax3: 0,
    BillStatusId: 1,
    DiscPercent: effectiveDiscPercent,
    DiscAmount: discountAmt ?? 0,
    OrderTime: t,
    OrderedDateTime: `${d}T${t}`,
    DeliveryTime: t,
    DeliveryDate: now.toISOString(),
    DeliveryDateTime: `${d}T${t}`,
    CreatedDateTime: now.toISOString(),
    ModifiedDateTime: now.toISOString(),
    ItmJson: JSON.stringify(items),
    ChargeJson: Macadd,
    icr: "M",
    TableName: tableNameNum,
    OrderedDate: d,
  };
}
 
// Creates the Razorpay order AND stashes a recovery marker in
// localStorage. If the tab dies right after this, the recovery effect
// (in PhonePage below) can still find its way back to this order.
async function createOrderAndStashPending({ custId, phoneNum, amountRupees, discount, discountAmt }) {
  const orderDraft = buildOrderDraft({ custId, phoneNum, discount, discountAmt });

  const ores = await fetch(`${BACKEND}/api/TestQr/create-order`, {
    method: "POST",
    mode: "cors",
    headers: { "Content-Type": "application/json" },
    body: JSON.stringify({
      Amount: Math.round(amountRupees * 100),
      Currency: "INR",
      Receipt: "ORD-" + Date.now(),
      OrderDraft: orderDraft,
    }),
  });
  if (!ores.ok) throw new Error("Payment init failed");
  const od = await ores.json();

  localStorage.setItem("pendingPayment", JSON.stringify({
    razorpayOrderId: od.orderId,
    storeName: localStorage.getItem("StoreName") || "Restaurant",
    logoUrl: localStorage.getItem("logo") || "",
    startedAt: Date.now(),
  }));

  return od;
}

// Call this once Razorpay's handler hands back razorpay_payment_id +
// razorpay_signature. The backend verifies + places the order itself.
async function verifyAndGetOrder(od, pr) {
  const vr = await fetch(`${BACKEND}/api/TestQr/verify`, {
    method: "POST",
    mode: "cors",
    headers: { "Content-Type": "application/json" },
    body: JSON.stringify({
      RazorpayOrderId: od.orderId,
      RazorpayPaymentId: pr.razorpay_payment_id,
      RazorpaySignature: pr.razorpay_signature,
    }),
  });
  const v = await vr.json();
  if (!v.success) throw new Error(v.error || "Payment verification failed");
  return v; // { orderId, orderNo, invoiceNo }
}

// After a successful /verify, build the same "tracking" shape the old
// local placeOrder() used to build, persist it, clear the cart, and
// trigger the receipt — same UX as before, just fed by the server's
// result instead of a local SP call.
// async function finalizeOnlineOrderUI({ result, total, discount, discountAmt, discountedTotal, storeName, logoUrl, navigate }) {
//   const cart = JSON.parse(localStorage.getItem("cart") || "[]");
//   const storeId = localStorage.getItem("StoreId");
//   const { items } = calcOrder(cart, storeId, discount ?? 0);

//   const tracking = {
//     invoiceNo: result.invoiceNo,
//     orderNo: `M-${String(result.orderNo).padStart(2, "0")}`,
//     total,
//     items,
//     orderType: localStorage.getItem("orderType") || "Take Away",
//     paymentType: "Online",
//     paid: true,
//     placedAt: Date.now(),
//     discount,
//     discountAmt,
//     discountedTotal,
//   };

//   localStorage.setItem("lastOrder", JSON.stringify(tracking));
//   localStorage.removeItem("pendingPayment"); // done — nothing left to recover

//   ["cart", "custid", "userPhone", "lastActiveCategory", "selectedFreeItems", "allowedFreeQty", "tableName"]
//     .forEach((k) => localStorage.removeItem(k));

//   await downloadAndSaveReceipt(tracking, storeName, logoUrl);
//   try { playSuccessSound(); } catch (_) {}

//   navigate("/order-tracking", { state: tracking, replace: true });
// }
async function finalizeOnlineOrderUI({ result, total, discount, discountAmt, discountedTotal, storeName, logoUrl, navigate, setLabel }) {
  const cart = JSON.parse(localStorage.getItem("cart") || "[]");
  const storeId = localStorage.getItem("StoreId");
  const { items } = calcOrder(cart, storeId, discount ?? 0);

  setLabel?.("Order confirmed! Finishing up…");

  const tracking = {
    invoiceNo: result.invoiceNo,
    orderNo: `M-${String(result.orderNo).padStart(2, "0")}`,
    total, items,
    orderType: localStorage.getItem("orderType") || "Take Away",
    paymentType: "Online",
    paid: true,
    placedAt: Date.now(),
    discount, discountAmt, discountedTotal,
  };

  localStorage.setItem("lastOrder", JSON.stringify(tracking));
  localStorage.removeItem("pendingPayment");

  ["cart", "custid", "userPhone", "lastActiveCategory", "selectedFreeItems", "allowedFreeQty", "tableName"]
    .forEach((k) => localStorage.removeItem(k));

  await downloadAndSaveReceipt(tracking, storeName, logoUrl, setLabel);
  try { playSuccessSound(); } catch (_) {}

  setLabel?.("Thank you to your order…");
  navigate("/order-tracking", { state: tracking, replace: true });
}
export default function PhonePage() {
  const [phone, setPhone]   = useState("");
  const [loading, setLoading] = useState(false);
  const [label, setLabel]   = useState("");
  const [toast, setToast]   = useState(null);
const [showIOSInstruction, setShowIOSInstruction] = useState(false);
  const location  = useLocation();
  const navigate  = useNavigate();
  const { total: stateTotal = 0, discount: discountFromCart = 0, cart: cartFromState = [] } = location.state || {};
  const total = stateTotal > 0
    ? stateTotal
    : parseFloat(localStorage.getItem("checkoutTotal") || "0");
  const cart = cartFromState.length > 0
    ? cartFromState
    : JSON.parse(localStorage.getItem("cart") || "[]");
  const Logo      = localStorage.getItem("logo");
  const storeName = localStorage.getItem("StoreName") || "Restaurant";
  const discount = parseFloat(
    discountFromCart || localStorage.getItem("storeDiscount") || "0"
  );
  const iosContinueResolveRef = React.useRef(null);

  const discountAmt        = computeEligibleDiscountAmt(cart, discount);
  const rawDiscountedTotal = total - discountAmt;
  const discountedTotal    = Math.round(rawDiscountedTotal);
  const roundOffDiff       = parseFloat((discountedTotal - rawDiscountedTotal).toFixed(2));

  const showToast = (msg, type = "error") => {
    setToast({ msg, type });
    setTimeout(() => setToast(null), 3500);
  };

  const handlePhoneChange = (e) => {
    const v = e.target.value.replace(/\D/g, "");
    if (v.length > 0 && !/^[6-9]/.test(v)) return;
    if (v.length <= 10) setPhone(v);
  };

  const isValidIndianPhone = (num) => /^[6-9]\d{9}$/.test(num);

  const phoneError =
    phone.length === 10 && !isValidIndianPhone(phone)
      ? "Indian mobile numbers must start with 6, 7, 8, or 9"
      : null;

  const phoneValid = phone.length === 10 && isValidIndianPhone(phone);

  // ── COD (Skip Payment) — unchanged, no gateway redirect involved ───────
  const handleCOD = async () => {
    localStorage.setItem("userPhone", "");
    localStorage.setItem("custid", "null");
    setLoading(true);
    setLabel("Placing your order…");
    try {
      const state = await placeOrder({
        custId: null,
        phoneNum: "",
        payTypeId: 2,
        paidAmt: 0,
        payOrdId: "COD",
        discountedTotal,
        discount,
        discountAmt,
      });
      navigate("/order-tracking", { state, replace: true });
    } catch (e) {
      console.error(e);
      showToast(
        e.message?.includes("fetch")
          ? "Network error — check connection & retry"
          : e.message || "Order failed",
        "error"
      );
    } finally {
      setLoading(false);
      setLabel("");
    }
  };

  // ── Guest Razorpay — order placement now happens server-side ───────────
  const handleGuestPay = async () => {
    localStorage.setItem("userPhone", "");
    localStorage.setItem("custid", "null");
    setLoading(true);
    setLabel("Connecting to payment…");
    try {
      if (!(await loadRazorpay())) throw new Error("Payment SDK failed to load");

      setLabel("Creating order…");
      const od = await createOrderAndStashPending({
        custId: null,
        phoneNum: "",
        amountRupees: total,
        discount,
        discountAmt,
      });

      setLabel("Waiting for payment…");
       if (isIOSDevice()) {
  // ── iOS only: show popup and wait for user to tap Continue ──
  setShowIOSInstruction(true);
  await new Promise((resolve) => {
    iosContinueResolveRef.current = resolve;
  });
  setShowIOSInstruction(false);
}
      const pr = await new Promise((res, rej) => {
        const rzp = new window.Razorpay({
          key: od.keyId,
          amount: od.amount,
          currency: "INR",
          order_id: od.orderId,
          name: storeName,
          description: "Food Order",
          theme: { color: "#c8102e" },
          handler: res,
          modal: { ondismiss: () => rej(new Error("Payment cancelled")) },
        });
        rzp.on("payment.failed", (r) => rej(r.error));
        rzp.open();
      });

      setLabel("Placing your order…");
      const result = await verifyAndGetOrder(od, pr);

      await finalizeOnlineOrderUI({
        result, total, discount, discountAmt, discountedTotal,
        storeName, logoUrl: Logo, navigate,
        setLabel, 
      });
    } catch (e) {
      console.error(e);
      // Do NOT clear "pendingPayment" here — if the payment actually
      // captured but this step failed for some other reason (e.g. network
      // drop), the recovery effect below will still pick it up later via
      // the webhook having already placed the order.
      if (e.message !== "Payment cancelled")
        showToast(e.message || "Something went wrong", "error");
    } finally {
      setLoading(false);
      setLabel("");
    }
  };

  // ── Razorpay with phone number — order placement now happens
  //    server-side (this is the fix for the iOS "order not placed" bug) ──
  const handlePay = async () => {
    if (!isValidIndianPhone(phone)) {
      showToast(
        "Enter a valid 10-digit Indian mobile number starting with 6, 7, 8, or 9"
      );
      return;
    }
    localStorage.setItem("userPhone", phone);
    setLoading(true);
    setLabel("Connecting to payment…");
    try {
      let custId = null;
      try {
        const cr = await saveCustomer(phone, localStorage.getItem("StoreId"));
        if (cr?.custid) {
          localStorage.setItem("custid", cr.custid);
          custId = cr.custid;
        }
      } catch (_) {}

      if (!(await loadRazorpay())) throw new Error("Please check your internet connection and try again");

      setLabel("Creating order…");
      const od = await createOrderAndStashPending({
        custId,
        phoneNum: phone,
        amountRupees: discountedTotal,
        discount,
        discountAmt,
      });

      setLabel("Waiting for payment…");
       if (isIOSDevice()) {
  // ── iOS only: show popup and wait for user to tap Continue ──
  setShowIOSInstruction(true);
  await new Promise((resolve) => {
    iosContinueResolveRef.current = resolve;
  });
  setShowIOSInstruction(false);
}
      const pr = await new Promise((res, rej) => {
        const rzp = new window.Razorpay({
          key: od.keyId,
          amount: od.amount,
          currency: "INR",
          order_id: od.orderId,
          name: storeName,
          description: "Food Order",
          prefill: { contact: phone },
          theme: { color: "#c8102e" },
          handler: res,
          modal: { ondismiss: () => rej(new Error("Payment cancelled")) },
        });
        rzp.on("payment.failed", (r) => rej(r.error));
        rzp.open();
      });

      setLabel("Placing your order…");
      const result = await verifyAndGetOrder(od, pr);

      await finalizeOnlineOrderUI({
        result, total, discount, discountAmt, discountedTotal,
        storeName, logoUrl: Logo, navigate,
        setLabel, 
      });
    } catch (e) {
      console.error(e);
      if (e.message !== "Payment cancelled")
        showToast(e.message || "Something went wrong", "error");
    } finally {
      setLoading(false);
      setLabel("");
    }
  };

  useEffect(() => {
    const storedCart = JSON.parse(localStorage.getItem("cart") || "[]");
    if (storedCart.length === 0) {
      navigate("/", { replace: true });
    }
  }, [navigate]);
useEffect(() => {
  const onVisible = () => {
    if (document.visibilityState === "visible") setShowIOSInstruction(false);
  };
  document.addEventListener("visibilitychange", onVisible);
  return () => document.removeEventListener("visibilitychange", onVisible);
}, []);
  // ── RECOVERY: if a payment was in flight when the tab died (the iOS
  //    case), this finds it on the next load and asks the backend whether
  //    the webhook already placed the order in the background. ───────────
  useEffect(() => {
    const pendingRaw = localStorage.getItem("pendingPayment");
    if (!pendingRaw) return;

    let pending;
    try { pending = JSON.parse(pendingRaw); } catch { return; }

    let attempts = 0;
    const maxAttempts = 20; // ~1 minute of polling, covers slow networks

    const poll = async () => {
      attempts += 1;
      try {
        const res = await fetch(`${BACKEND}/api/TestQr/order-status/${pending.razorpayOrderId}`);
        if (res.ok) {
          const s = await res.json();
          if (s.status === "COMPLETED") {
            localStorage.removeItem("pendingPayment");
            showToast("Your earlier payment went through — order placed!", "success");
            navigate("/order-tracking", {
              state: {
                invoiceNo: s.invoiceNo,
                orderNo: `M-${String(s.orderNo).padStart(2, "0")}`,
                paid: true,
                placedAt: pending.startedAt,
              },
              replace: true,
            });
            return;
          }
          if (s.status === "FAILED") {
            localStorage.removeItem("pendingPayment");
            return;
          }
        }
      } catch (_) { /* network hiccup — just retry */ }

      if (attempts < maxAttempts) setTimeout(poll, 3000);
      else localStorage.removeItem("pendingPayment");
    };

    poll();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  // ── HARD LOCK: back button is illegal during any payment-critical state ──
  useEffect(() => {
    const isCriticalState = loading;
    if (!isCriticalState) return;

    window.history.pushState({ locked: true }, "", window.location.href);

    const block = (e) => {
      window.history.pushState({ locked: true }, "", window.location.href);
      showToast("Please wait — payment is being processed. Do not go back.", "error");
    };

    window.addEventListener("popstate", block);

    const preventEdgeSwipe = (e) => {
      if (e.touches[0].clientX < 30 || e.touches[0].clientX > window.innerWidth - 30) {
        e.preventDefault();
      }
    };
    document.addEventListener("touchstart", preventEdgeSwipe, { passive: false });

    const blockUnload = (e) => { e.preventDefault(); e.returnValue = ""; };
    window.addEventListener("beforeunload", blockUnload);

    return () => {
      window.removeEventListener("popstate", block);
      document.removeEventListener("touchstart", preventEdgeSwipe);
      window.removeEventListener("beforeunload", blockUnload);
    };
  }, [loading]);

  return (
    <div className="pp-root">
      {loading && (
        <div
          style={{
            position: "fixed", inset: 0, background: "rgba(245,240,235,0.96)",
            display: "flex", alignItems: "center", justifyContent: "center",
            zIndex: 999, flexDirection: "column", gap: 18,
          }}
        >
          {Logo && Logo !== "null" ? (
            <div style={{ position: "relative", width: 84, height: 84 }}>
              <div
                style={{
                  position: "absolute", inset: 0, borderRadius: "50%",
                  border: "3px solid #e8e0d8", borderTop: "3px solid #c8102e",
                  animation: "pp-spin 0.85s linear infinite",
                }}
              />
              <img
                src={Logo}
                alt=""
                style={{
                  position: "absolute", inset: 7,
                  width: "calc(100% - 14px)", height: "calc(100% - 14px)",
                  borderRadius: "50%", objectFit: "cover",
                }}
              />
            </div>
          ) : (
            <div
              style={{
                width: 56, height: 56, border: "4px solid #e8e0d8",
                borderTop: "4px solid #c8102e", borderRadius: "50%",
                animation: "pp-spin 0.8s linear infinite",
              }}
            />
          )}
          <span style={{ fontSize: 15, color: "#4a4a4a", fontWeight: 600 }}>
            {label || "Please wait…"}
          </span>
        </div>
      )}

      {toast && (
        <div
          className="pp-toast"
          style={{
            background: toast.type === "error" ? "#fdecea" : "#e8f5e9",
            color: toast.type === "error" ? "#9b0d22" : "#1b5e20",
            border: `1px solid ${toast.type === "error" ? "#f5c6c6" : "#a5d6a7"}`,
            boxShadow: "0 4px 20px rgba(0,0,0,0.10)",
          }}
        >
          {toast.msg}
        </div>
      )}

      <div
        style={{
          width: "100%", background: "#1a1a1a", height: 72, display: "flex",
          alignItems: "center", padding: "0 16px", gap: 12,
          position: "sticky", top: 0, zIndex: 10,
        }}
      >
        <button
          onClick={() => {
            localStorage.removeItem("custid");
            localStorage.removeItem("userPhone");
            navigate("/cart", { replace: true });
          }}
          style={{
            width: "44px", height: "44px", borderRadius: "50%",
            background: "rgba(255,255,255,0.08)",
            border: "1px solid rgba(212,175,55,0.3)",
            color: "#d4af37", display: "flex", alignItems: "center",
            justifyContent: "center", cursor: "pointer", fontSize: "20px",
            fontWeight: "400", transition: "all 0.3s cubic-bezier(0.4,0,0.2,1)",
            backdropFilter: "blur(10px)",
          }}
        >
          <svg width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2.5" strokeLinecap="round" strokeLinejoin="round">
            <polyline points="15 18 9 12 15 6" />
          </svg>
        </button>
        <span style={{ color: "#fff", fontSize: 15, fontWeight: 700, flex: 1 }}>
          {storeName}
        </span>
        <span
         style={{
              background: "#c8102e", color: "#fff", fontSize: 10, fontWeight: 700,
               padding: "3px 10px", borderRadius: 99, letterSpacing: 0.5,
            }}
        >
          CHECKOUT
        </span>
      </div>

      <div className="pp-body"
        style={{
          width: "100%", maxWidth: 420, padding: "20px 16px",
          display: "flex", flexDirection: "column", gap: 14,
        }}
      >
        <div
           style={{
     background: "rgb(123 4 4)", borderRadius: 20,
     padding: "15px 20px", textAlign: "center",
  }}
        >
          <p style={{ fontSize: 11, color: "#fff", textTransform: "uppercase", letterSpacing: 1.5, margin: "0 0 4px" }}>
            Total to pay (inc. taxes)
          </p>

          {discountAmt > 0 && (
            <div style={{ display: "flex", alignItems: "center", justifyContent: "center", gap: 10, marginBottom: 6 }}>
              <span style={{ fontSize: 28, color: "rgba(255,255,255,0.5)", textDecoration: "line-through", fontWeight: 700 }}>
                ₹{parseFloat(total).toFixed(2)}
              </span>
              <span style={{ background: "#16a34a", color: "#fff", fontSize: 11, fontWeight: 700, padding: "3px 10px", borderRadius: 99, letterSpacing: 0.5 }}>
                {discount}% OFF
              </span>
            </div>
          )}

          <div style={{ display: "flex", alignItems: "center", justifyContent: "center", gap: 8, margin: "0 0 4px" }}>
            <p style={{ fontSize: 46, fontWeight: 800, color: "#fff", margin: 0, letterSpacing: -1 }}>
              ₹{discountedTotal.toFixed(2)}
            </p>
            {Math.abs(roundOffDiff) > 0.001 && (
              <RoundOffBadge diff={roundOffDiff} />
            )}
          </div>

          {discountAmt > 0 && (
            <div style={{ display: "flex", alignItems: "center", justifyContent: "center", gap: 6, marginTop: 6 }}>
              <div style={{ width: 6, height: 6, borderRadius: "50%", background: "#4ade80" }} />
              <span style={{ fontSize: 12, color: "#a7f3d0", fontWeight: 500 }}>
                You save ₹{discountAmt.toFixed(2)}
              </span>
            </div>
          )}
        </div>

        <div className="pp-card">
          <p style={{ fontSize: 12, color: "#888", marginBottom: 16 }}>
            Enter your mobile number
          </p>

          <div
            className="pp-input-row"
            style={{
              marginBottom: phoneError ? 6 : 10,
              borderColor: phoneError ? "#e53e3e" : undefined,
            }}
          >
            <span style={{ fontSize: 14, fontWeight: 700, color: "#888" }}>+91</span>
            <div style={{ width: 1, height: 24, background: "#e8e0d8" }} />
            <div style={{ position: "relative", flex: 1, display: "flex", alignItems: "center" }}>
              <input
                type="tel"
                inputMode="numeric"
                pattern="[0-9]*"
                maxLength="10"
                value={phone}
                onChange={handlePhoneChange}
                placeholder="Mobile number"
                autoFocus
                onFocus={(e) => {
                  setTimeout(() => {
                    e.target.scrollIntoView({ behavior: "smooth", block: "center" });
                  }, 300);
                }}
                style={{ width: "100%", paddingRight: phoneValid ? 30 : 0 }}
              />
              {phoneValid && (
                <div
                  style={{
                    width: 22, height: 22, borderRadius: "50%", background: "#16a34a",
                    display: "flex", alignItems: "center", justifyContent: "center",
                    flexShrink: 0,
                  }}
                >
                  <svg width="11" height="11" viewBox="0 0 12 12" fill="none">
                    <path
                      d="M2 6l3 3 5-5"
                      stroke="#fff"
                      strokeWidth="2"
                      strokeLinecap="round"
                      strokeLinejoin="round"
                    />
                  </svg>
                </div>
              )}
            </div>
          </div>

          {phoneError && (
            <p style={{ fontSize: 11, color: "#e53e3e", margin: "0 0 10px", fontWeight: 500 }}>
              ⚠ {phoneError}
            </p>
          )}

          <div style={{ display: "flex", gap: 5, marginBottom: 18 }}>
            {Array.from({ length: 10 }, (_, i) => (
              <div key={i} className={`pp-dot${i < phone.length ? " on" : ""}`} />
            ))}
          </div>

          <button
            className="pp-btn"
            onClick={handlePay}
            disabled={loading || !phoneValid}
            style={{
              background: phoneValid && !loading ? "#c8102e" : "#e8e0d8",
              color: phoneValid && !loading ? "#fff" : "#aaa",
              border: "none",
              marginBottom: 10,
            }}
          >
            {loading && label ? (
              <>
                <span className="pp-spinner" />
                {label}
              </>
            ) : !phoneValid ? (
              "Enter valid number to pay online"
            ) : (
              <>
                Pay ₹{discountedTotal.toFixed(0)}
                <svg
                  width="18"
                  height="18"
                  viewBox="0 0 24 24"
                  fill="none"
                  stroke="currentColor"
                  strokeWidth="4"
                  strokeLinecap="round"
                  strokeLinejoin="round"
                >
                  <polyline points="9 18 15 12 9 6" />
                </svg>
              </>
            )}
          </button>

          {/* <div
            style={{
              display: "flex", alignItems: "center", gap: 10, margin: "0 0 14px",
            }}
          >
            <div style={{ flex: 1, height: 1, background: "#f0ebe5" }} />
            <span style={{ fontSize: 12, color: "#bbb", whiteSpace: "nowrap" }}>
              or
            </span>
            <div style={{ flex: 1, height: 1, background: "#f0ebe5" }} />
          </div> */}

          {/* <button
            className="pp-btn"
            onClick={handleCOD}
            disabled={loading}
            style={{
              background: "#fff",
              border: "1.5px solid #e8e0d8",
              color: "#1a1a1a",
            }}
          >
            <svg width="16" height="16" viewBox="0 0 16 16" fill="none">
              <rect x="1" y="3" width="14" height="10" rx="2" stroke="#4a4a4a" strokeWidth="1.4" />
              <path
                d="M1 7h14M5 10.5h2M9 10.5h2"
                stroke="#4a4a4a"
                strokeWidth="1.4"
                strokeLinecap="round"
              />
            </svg>
            Skip Payment
          </button> */}
        </div>
      </div>
      {showIOSInstruction && (
  <div
    style={{
      position: "fixed", inset: 0, background: "rgba(0,0,0,0.55)",
      display: "flex", alignItems: "center", justifyContent: "center",
      zIndex: 1500, padding: 20,
    }}
  >
    <div
      style={{
        background: "#fff", borderRadius: 16, padding: 24,
        maxWidth: 320, textAlign: "center",
      }}
    >
      <p style={{ fontSize: 15, fontWeight: 700, color: "#1a1a1a", marginBottom: 8 }}>
        After paying in your UPI app
      </p>
      <p style={{ fontSize: 13, color: "#555", marginBottom: 18, lineHeight: 1.5 }}>
        Please switch back to this browser tab to see your order confirmation.
      </p>
      <button
  className="pp-btn"
  onClick={() => {
    if (iosContinueResolveRef.current) {
      iosContinueResolveRef.current();
      iosContinueResolveRef.current = null;
    }
  }}
  style={{ background: "#c8102e", color: "#fff", border: "none" }}
>
  Continue to Pay
</button>
    </div>
  </div>
)}
    </div>
  );
}